import React, { useState, useMemo } from "react";
import {
  IconPlus,
  IconSearch,
  IconFilter,
  IconTrash,
  IconUpload,
  IconDownload,
  IconRefresh,
  IconChevronRight,
  IconChevronLeft,
  IconDots,
  IconDotsVertical,
  IconX,
  IconLayoutGrid,
  IconEdit,
  IconDeviceFloppy,
  IconPackage,
  IconFileText,
  IconClock,
  IconCheck,
  IconSettings,
} from "@tabler/icons-react";
import toast from "react-hot-toast";
import {
  fetchAssetUniqueCodeSettings,
  updateAssetUniqueCodeSettings,
  fetchAssetTypes,
  createAssetType,
  updateAssetType,
  deleteAssetType
} from "../../../apis/hrApi";


interface Asset {
  id: string;
  name: string;
  type: string;
  picture: string;
  totalStock: string | number;
  availableStock: number;
  lentTo: string | number;
  createdAt: string;
  updatedAt: string;
  description?: string;
}

interface AssetRequest {
  id: string;
  type: string;
  asset: string;
  project: string;
  task: string;
  subTask: string;
  vendor: string;
  requestedBy: string;
  quantity: string | number;
  acceptedQuantity: string | number;
  remarks: string;
  status: "Pending" | "Received" | "Scheduled" | "Not Received";
  createdAt: string;
  updatedAt: string;
}

interface StockItem {
  id: string;
  serialNo: string;
  companyName: string;
  assetValue: string;
  vendor: string;
  purchaseDate: string;
  warrantyDate: string;
  insuranceStartDate: string;
  insuranceEndDate: string;
  insurancePremium: string;
  modelNumber: string;
  location: string;
  department: string;
  specification: string;
  status: "Available" | "Issued" | "Lost" | "Damage" | "Non Functional" | "Under Maintenance";
  warrantyStatus: "In Warranty" | "Expired";
  createdAt: string;
  updatedAt: string;
}

interface StockFormItem {
  serialNo: string;
  vendor: string;
  companyName: string;
  assetValue: string;
  purchaseDate: string;
  warrantyDate: string;
  insuranceStartDate: string;
  insuranceEndDate: string;
  insurancePremium: string;
  modelNumber: string;
  location: string;
  department: string;
  specification: string;
  attachmentName: string;
}

const INITIAL_ASSETS: Asset[] = [
  { id: "ASS#005", name: "Speaker", type: "Electronics", picture: "No Image", totalStock: "Low Stock", availableStock: 0, lentTo: "-", createdAt: "26-06-2026 01:13 PM", updatedAt: "18-07-2026 03:30 PM", description: "xd" },
  { id: "ASS#004", name: "Tables set", type: "Land and Property", picture: "https://images.unsplash.com/photo-1544025162-d76694265947?w=120", totalStock: 8, availableStock: 3, lentTo: 8, createdAt: "17-06-2026 04:14 PM", updatedAt: "18-07-2026 03:30 PM", description: "Office desks and chairs set" },
  { id: "ASS#003", name: "Assets1", type: "Display", picture: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=120", totalStock: 1, availableStock: 0, lentTo: 1, createdAt: "17-06-2026 04:11 PM", updatedAt: "18-07-2026 03:30 PM", description: "Smart interactive display board" },
  { id: "ASS#002", name: "Mobile", type: "-", picture: "No Image", totalStock: "Low Stock", availableStock: 0, lentTo: "-", createdAt: "11-05-2026 06:47 PM", updatedAt: "18-07-2026 03:30 PM", description: "Android testing mobile device" },
  { id: "ASS#001", name: "Workstation Laptop 1", type: "-", picture: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=120", totalStock: 12, availableStock: 0, lentTo: 2, createdAt: "03-11-2025 06:01 PM", updatedAt: "18-07-2026 03:30 PM", description: "Developer workstation laptop" },
  { id: "Ass#010", name: "chair", type: "device", picture: "https://images.unsplash.com/photo-1580481072645-022f9a6dbf27?w=120", totalStock: 2, availableStock: 0, lentTo: 2, createdAt: "14-10-2025 03:43 PM", updatedAt: "18-07-2026 03:30 PM", description: "Ergonomic mesh office chair" },
  { id: "Ass#009", name: "router", type: "device", picture: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=120", totalStock: 2, availableStock: 0, lentTo: 2, createdAt: "14-10-2025 03:43 PM", updatedAt: "18-07-2026 03:30 PM", description: "Dual-band WiFi Gigabit router" },
  { id: "Ass#008", name: "keyboard", type: "device", picture: "https://images.unsplash.com/photo-1587829741301-dc798b83add3?w=120", totalStock: 8, availableStock: 0, lentTo: 3, createdAt: "14-10-2025 03:40 PM", updatedAt: "18-07-2026 03:30 PM", description: "Wireless mechanical keyboard" },
  { id: "Ass#007", name: "mouse", type: "device", picture: "https://images.unsplash.com/photo-1615663245857-ac93bb7c39e7?w=120", totalStock: 3, availableStock: 0, lentTo: 2, createdAt: "14-10-2025 03:40 PM", updatedAt: "18-07-2026 03:30 PM", description: "Ergonomic vertical wireless mouse" },
  { id: "Ass#006", name: "pendrive", type: "device", picture: "https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=120", totalStock: "Low Stock", availableStock: 0, lentTo: "-", createdAt: "14-10-2025 03:37 PM", updatedAt: "18-07-2026 03:30 PM", description: "USB 3.2 Flash Drive 64GB" }
];

const INITIAL_REQUESTS: AssetRequest[] = [
  { id: "REQ#076", type: "Stock Request", asset: "Mobile Phone", project: "Someshwar Square", task: "Last Task", subTask: "-", vendor: "-", requestedBy: "YK", quantity: 10, acceptedQuantity: "-", remarks: "-", status: "Pending", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#073", type: "Project Asset Request", asset: "Tables set", project: "Someshwar Square", task: "Task5", subTask: "-", vendor: "-", requestedBy: "YK", quantity: "-", acceptedQuantity: "-", remarks: "-", status: "Received", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#072", type: "Project Asset Request", asset: "Tables set", project: "Someshwar Square", task: "Task5", subTask: "-", vendor: "-", requestedBy: "YK", quantity: "-", acceptedQuantity: "-", remarks: "-", status: "Scheduled", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#071", type: "Project Asset Request", asset: "Tables set", project: "Someshwar Square", task: "Task5", subTask: "-", vendor: "-", requestedBy: "YK", quantity: "-", acceptedQuantity: "-", remarks: "-", status: "Received", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#070", type: "Project Asset Request", asset: "Tables set", project: "Someshwar Square", task: "Task5", subTask: "-", vendor: "-", requestedBy: "YK", quantity: "-", acceptedQuantity: "-", remarks: "-", status: "Not Received", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#069", type: "Project Asset Request", asset: "Tables set", project: "Someshwar Square", task: "Task5", subTask: "-", vendor: "-", requestedBy: "YK", quantity: "-", acceptedQuantity: "-", remarks: "-", status: "Pending", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#067", type: "Stock Request", asset: "Speaker", project: "-", task: "-", subTask: "-", vendor: "-", requestedBy: "YK", quantity: 2, acceptedQuantity: "-", remarks: "-", status: "Pending", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#066", type: "Emp Asset Request", asset: "-", project: "-", task: "-", subTask: "-", vendor: "-", requestedBy: "YK", quantity: "-", acceptedQuantity: "-", remarks: "-", status: "Pending", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#065", type: "Stock Request", asset: "pendrive", project: "-", task: "-", subTask: "-", vendor: "-", requestedBy: "D", quantity: 3, acceptedQuantity: "-", remarks: "-", status: "Pending", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" },
  { id: "REQ#064", type: "Stock Request", asset: "pendrive", project: "-", task: "-", subTask: "-", vendor: "-", requestedBy: "D", quantity: 5, acceptedQuantity: "-", remarks: "-", status: "Pending", createdAt: "10-07-2026 06:11 PM", updatedAt: "10-07-2026 06:11 PM" }
];

const API_KEY_MAP: Record<string, string> = {
  asset: "ASSET",
  stock: "ASSET_STOCK",
  request: "ASSET_REQUEST",
  maintenance: "ASSET_MAINTENANCE",
  insurance: "ASSET_INSURANCE_WARRANTY",
  depreciation: "ASSET_DEPRECIATION",
  allocation: "ASSET_ALLOCATION_USAGE",
};

export default function AssetPage() {
  const [activeTab, setActiveTab] = useState<"assets" | "requests">("assets");
  const [assets, setAssets] = useState<Asset[]>(INITIAL_ASSETS);
  const [requests, setRequests] = useState<AssetRequest[]>(INITIAL_REQUESTS);

  // Stock Records state (Keyed by Asset ID)
  const [stocks, setStocks] = useState<Record<string, StockItem[]>>({});

  // Detail View State
  const [selectedAssetForDetail, setSelectedAssetForDetail] = useState<Asset | null>(null);
  const [detailActiveTab, setDetailActiveTab] = useState<"stock" | "activity">("stock");

  // Edit / Delete states
  const [selectedAssetForEdit, setSelectedAssetForEdit] = useState<Asset | null>(null);
  const [selectedAssetForDelete, setSelectedAssetForDelete] = useState<Asset | null>(null);

  // Asset Types list
  const [assetTypes, setAssetTypes] = useState<{ id?: string; name: string; isDefault: boolean; isConstruction: boolean }[]>([]);
  const [isAssetTypesLoading, setIsAssetTypesLoading] = useState(false);

  // Projects, Tasks, Sub Tasks
  const [projects] = useState<string[]>(["Someshwar Square", "Giga Project A", "Alpha Tower", "-"]);
  const [tasks] = useState<string[]>(["Last Task", "Task5", "Design Phase", "-"]);
  const [subTasks] = useState<string[]>(["Sub Task 1", "Sub Task 2", "-"]);
  const [vendors] = useState<string[]>(["Vendor A", "Vendor B", "Global IT Supplies", "Logistics Ltd"]);
  const [departments] = useState<string[]>(["HR", "Engineering", "Operations", "Finance", "Sales"]);

  // Search & Filter states
  const [searchQuery, setSearchQuery] = useState("");
  const [assetTypeFilter, setAssetTypeFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [reqTypeFilter, setReqTypeFilter] = useState("All");

  // Stock Search / Filter states
  const [stockSearchQuery, setStockSearchQuery] = useState("");
  const [stockStatusFilter, setStockStatusFilter] = useState("All");
  const [stockWarrantyFilter, setStockWarrantyFilter] = useState("All");

  // Selection states
  const [selectedAssets, setSelectedAssets] = useState<string[]>([]);
  const [selectedRequests, setSelectedRequests] = useState<string[]>([]);
  const [selectedStocks, setSelectedStocks] = useState<string[]>([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [stockCurrentPage, setStockCurrentPage] = useState(1);
  const [stockPageSize, setStockPageSize] = useState(10);

  // Reset page numbers on filter / tab changes
  React.useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, assetTypeFilter, statusFilter, reqTypeFilter, activeTab]);

  React.useEffect(() => {
    setStockCurrentPage(1);
  }, [stockSearchQuery, stockStatusFilter, stockWarrantyFilter, selectedAssetForDetail]);

  // Asset Settings States
  const [isSettingPageOpen, setIsSettingPageOpen] = useState(false);
  const [settingsTab, setSettingsTab] = useState<"code" | "type">("code");
  const [assetTypeSearchQuery, setAssetTypeSearchQuery] = useState("");
  const [assetTypePage, setAssetTypePage] = useState(1);
  const ASSET_TYPE_PAGE_SIZE = 10;
  
  // Unique Identify Code settings
  const [codeSettings, setCodeSettings] = useState<Record<string, { seriesCode: string; connector: string; sequenceLength: number }>>({
    asset: { seriesCode: "ASS", connector: "#", sequenceLength: 3 },
    stock: { seriesCode: "STOCK", connector: "#", sequenceLength: 3 },
    request: { seriesCode: "REQ", connector: "#", sequenceLength: 3 },
    maintenance: { seriesCode: "null", connector: "null", sequenceLength: 3 },
    insurance: { seriesCode: "null", connector: "null", sequenceLength: 3 },
    depreciation: { seriesCode: "null", connector: "null", sequenceLength: 3 },
    allocation: { seriesCode: "null", connector: "null", sequenceLength: 3 },
  });

  const [isCodeSettingsLoading, setIsCodeSettingsLoading] = useState(false);
  const [isCodeSettingsSaving, setIsCodeSettingsSaving] = useState(false);

  // Load code settings from backend API
  const loadCodeSettings = React.useCallback(async () => {
    setIsCodeSettingsLoading(true);
    try {
      const res = await fetchAssetUniqueCodeSettings();
      if (res.success && Array.isArray(res.data)) {
        const mapped: Record<string, { seriesCode: string; connector: string; sequenceLength: number }> = {
          asset: { seriesCode: "ASS", connector: "#", sequenceLength: 3 },
          stock: { seriesCode: "STOCK", connector: "#", sequenceLength: 3 },
          request: { seriesCode: "REQ", connector: "#", sequenceLength: 3 },
          maintenance: { seriesCode: "null", connector: "null", sequenceLength: 3 },
          insurance: { seriesCode: "null", connector: "null", sequenceLength: 3 },
          depreciation: { seriesCode: "null", connector: "null", sequenceLength: 3 },
          allocation: { seriesCode: "null", connector: "null", sequenceLength: 3 },
        };
        res.data.forEach((item: any) => {
          const key = Object.keys(API_KEY_MAP).find(k => API_KEY_MAP[k] === item.type);
          if (key) {
            mapped[key] = {
              seriesCode: item.seriesCode || "",
              connector: item.connector || "",
              sequenceLength: Number(item.sequenceLength) || 3,
            };
          }
        });
        setCodeSettings(mapped);
      }
    } catch (err: any) {
      console.error("Error loading unique code settings:", err);
      toast.error(err.message || "Failed to load unique code settings");
    } finally {
      setIsCodeSettingsLoading(false);
    }
  }, []);

  // Fetch unique code settings on component mount or when settings panel opens
  React.useEffect(() => {
    if (isSettingPageOpen) {
      loadCodeSettings();
    }
  }, [isSettingPageOpen, loadCodeSettings]);

  // Load asset types from backend
  const loadAssetTypes = React.useCallback(async () => {
    setIsAssetTypesLoading(true);
    try {
      const res = await fetchAssetTypes(1, 100);
      if (res.success && res.data) {
        let list: any[] = [];
        if (Array.isArray(res.data)) {
          list = res.data;
        } else if (typeof res.data === "object") {
          const possible =
            res.data.assetTypes ||
            res.data.assetType ||
            res.data.list ||
            res.data.data;
          if (Array.isArray(possible)) {
            list = possible;
          } else {
            const found = Object.values(res.data).find(Array.isArray);
            if (found) list = found as any[];
          }
        }
        setAssetTypes(
          list.map((item: any) => ({
            id: item.id || item._id,
            name: item.name || "",
            isDefault: !!item.isDefault,
            isConstruction: !!item.isConstructionAssetType || !!item.isConstruction,
          }))
        );
        setAssetTypePage(1);
      }
    } catch (err: any) {
      console.error("Error loading asset types:", err);
      toast.error(err.message || "Failed to load asset types");
    } finally {
      setIsAssetTypesLoading(false);
    }
  }, []);

  // Fetch asset types on component mount
  React.useEffect(() => {
    loadAssetTypes();
  }, [loadAssetTypes]);

  // Save settings via backend API
  const handleSaveSettings = async () => {
    setIsCodeSettingsSaving(true);
    try {
      const payload = Object.entries(codeSettings).map(([key, value]) => ({
        type: API_KEY_MAP[key] || key.toUpperCase(),
        seriesCode: value.seriesCode,
        connector: value.connector,
        sequenceLength: Number(value.sequenceLength),
      }));

      const res = await updateAssetUniqueCodeSettings(payload);
      if (res.success) {
        toast.success("Unique Identify Code settings saved successfully!");
        setIsSettingPageOpen(false);
      } else {
        toast.error(res.message || "Failed to save unique code settings");
      }
    } catch (err: any) {
      console.error("Error saving unique code settings:", err);
      toast.error(err.message || "Failed to save unique code settings");
    } finally {
      setIsCodeSettingsSaving(false);
    }
  };

  const getCodePreview = (series: string, conn: string, length: number) => {
    if (series === "null" || conn === "null") return "null";
    const numStr = "1".padStart(length, "0");
    return `${series}${conn}${numStr}`;
  };

  // Asset Settings modals / actions
  const [settingsTypeModalMode, setSettingsTypeModalMode] = useState<"ADD_TYPE" | "EDIT_TYPE" | "DELETE_TYPE" | null>(null);
  const [selectedTypeForSetting, setSelectedTypeForSetting] = useState<{ id?: string; name: string; isDefault: boolean; isConstruction: boolean } | null>(null);
  const [isAssetTypeSubmitting, setIsAssetTypeSubmitting] = useState(false);
  const [newSettingTypeName, setNewSettingTypeName] = useState("");
  const [newSettingTypeIsConstruction, setNewSettingTypeIsConstruction] = useState(false);
  const [newSettingTypeNameError, setNewSettingTypeNameError] = useState("");
  const [settingsTypeActiveActionMenuName, setSettingsTypeActiveActionMenuName] = useState<string | null>(null);

  // Sidebar controls
  const [sidebarMode, setSidebarMode] = useState<
    "ADD_ASSET" | "IMPORT_ASSET" | "ADD_REQUEST" | "IMPORT_REQUEST" | "ASSET_TYPE" | "FILTER_REQUEST" | "VIEW_REQUEST" | "DELETE_REQUEST_CONFIRM" | "EDIT_ASSET" | "DELETE_ASSET_CONFIRM" | null
  >(null);
  const [backMode, setBackMode] = useState<typeof sidebarMode>(null);

  // Stock inline panel mode (slides in next to the table only)
  const [stockPanelMode, setStockPanelMode] = useState<"ADD_STOCK" | "IMPORT_STOCK" | "FILTER_STOCK" | null>(null);
  
  // Selected detail states
  const [selectedReqForView, setSelectedReqForView] = useState<AssetRequest | null>(null);
  const [selectedReqForDelete, setSelectedReqForDelete] = useState<AssetRequest | null>(null);

  // Action menus
  const [activeActionMenuId, setActiveActionMenuId] = useState<string | null>(null);

  // Form states
  const [newAssetName, setNewAssetName] = useState("");
  const [newAssetType, setNewAssetType] = useState("Electronics");
  const [newAssetDesc, setNewAssetDesc] = useState("");
  const [newAssetFile, setNewAssetFile] = useState<File | null>(null);
  const [newAssetFileName, setNewAssetFileName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Request Form states
  const [newReqAsset, setNewReqAsset] = useState("");
  const [newReqAssetType, setNewReqAssetType] = useState("");
  const [newReqType, setNewReqType] = useState("Stock Request");
  const [newReqQty, setNewReqQty] = useState("");
  const [newReqProject, setNewReqProject] = useState("");
  const [newReqTask, setNewReqTask] = useState("");
  const [newReqSubTask, setNewReqSubTask] = useState("");
  const [newReqPriority, setNewReqPriority] = useState("");
  const [newReqPurchaseType, setNewReqPurchaseType] = useState("Permanently");
  const [newReqJustification, setNewReqJustification] = useState("");

  // New Asset Type modal states
  const [newAssetTypeName, setNewAssetTypeName] = useState("");
  const [editingAssetTypeIdx, setEditingAssetTypeIdx] = useState<number | null>(null);

  // Dynamic Add Stock form state (an array of form objects)
  const [stockFormItems, setStockFormItems] = useState<StockFormItem[]>([
    {
      serialNo: "",
      vendor: "",
      companyName: "",
      assetValue: "",
      purchaseDate: "",
      warrantyDate: "",
      insuranceStartDate: "",
      insuranceEndDate: "",
      insurancePremium: "",
      modelNumber: "",
      location: "",
      department: "",
      specification: "",
      attachmentName: ""
    }
  ]);

  const isSidebarOpen = sidebarMode !== null;

  // Filter lists
  const filteredAssets = useMemo(() => {
    return assets.filter(a => {
      const matchesSearch = a.name.toLowerCase().includes(searchQuery.toLowerCase()) || a.id.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesType = assetTypeFilter === "All" || a.type === assetTypeFilter;
      return matchesSearch && matchesType;
    });
  }, [assets, searchQuery, assetTypeFilter]);

  const filteredRequests = useMemo(() => {
    return requests.filter(r => {
      const matchesSearch = r.asset.toLowerCase().includes(searchQuery.toLowerCase()) || r.id.toLowerCase().includes(searchQuery.toLowerCase()) || r.project.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesStatus = statusFilter === "All" || r.status === statusFilter;
      const matchesReqType = reqTypeFilter === "All" || r.type === reqTypeFilter;
      return matchesSearch && matchesStatus && matchesReqType;
    });
  }, [requests, searchQuery, statusFilter, reqTypeFilter]);

  // Filtered Stock Items under dynamic detailed view
  const filteredStocksList = useMemo(() => {
    if (!selectedAssetForDetail) return [];
    const rawList = stocks[selectedAssetForDetail.id] || [];
    return rawList.filter(s => {
      const matchesSearch = s.serialNo.toLowerCase().includes(stockSearchQuery.toLowerCase()) || s.vendor.toLowerCase().includes(stockSearchQuery.toLowerCase());
      const matchesStatus = stockStatusFilter === "All" || s.status === stockStatusFilter;
      const matchesWarranty = stockWarrantyFilter === "All" || s.warrantyStatus === stockWarrantyFilter;
      return matchesSearch && matchesStatus && matchesWarranty;
    });
  }, [stocks, selectedAssetForDetail, stockSearchQuery, stockStatusFilter, stockWarrantyFilter]);

  // Paginated lists
  const paginatedAssets = useMemo(() => {
    return filteredAssets.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  }, [filteredAssets, currentPage, pageSize]);

  const paginatedRequests = useMemo(() => {
    return filteredRequests.slice((currentPage - 1) * pageSize, currentPage * pageSize);
  }, [filteredRequests, currentPage, pageSize]);

  const paginatedStocksList = useMemo(() => {
    return filteredStocksList.slice((stockCurrentPage - 1) * stockPageSize, stockCurrentPage * stockPageSize);
  }, [filteredStocksList, stockCurrentPage, stockPageSize]);

  // Handlers
  const handleAddAssetSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newAssetName.trim()) {
      toast.error("Asset name is required");
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      if (sidebarMode === "EDIT_ASSET" && selectedAssetForEdit) {
        setAssets(prev => prev.map(a => {
          if (a.id === selectedAssetForEdit.id) {
            return {
              ...a,
              name: newAssetName.trim(),
              type: newAssetType,
              description: newAssetDesc,
              updatedAt: new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " " + new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
            };
          }
          return a;
        }));
        toast.success("Asset updated successfully!");
      } else {
        const added: Asset = {
          id: `ASS#0${assets.length + 11}`,
          name: newAssetName.trim(),
          type: newAssetType,
          picture: "No Image",
          totalStock: 1,
          availableStock: 1,
          lentTo: "-",
          createdAt: new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " " + new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }),
          updatedAt: new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " " + new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }),
          description: newAssetDesc
        };
        setAssets([added, ...assets]);
        toast.success("Asset added successfully!");
      }
      setNewAssetName("");
      setNewAssetDesc("");
      setNewAssetFile(null);
      setNewAssetFileName("");
      setIsSubmitting(false);

      if (backMode) {
        setSidebarMode(backMode);
        setBackMode(null);
      } else {
        setSidebarMode(null);
      }
    }, 800);
  };

  const handleAddRequestSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!newReqAsset.trim()) {
      toast.error("Asset name is required");
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      const added: AssetRequest = {
        id: `REQ#0${requests.length + 77}`,
        type: newReqType,
        asset: newReqAsset.trim(),
        project: newReqProject.trim() || "-",
        task: newReqTask.trim() || "-",
        subTask: newReqSubTask.trim() || "-",
        vendor: "-",
        requestedBy: "YK",
        quantity: newReqQty || "-",
        acceptedQuantity: "-",
        remarks: newReqJustification || "-",
        status: "Pending",
        createdAt: new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " " + new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }),
        updatedAt: new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " " + new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
      };
      setRequests([added, ...requests]);
      toast.success("Requisition added successfully!");
      setNewReqAsset("");
      setNewReqAssetType("");
      setNewReqQty("");
      setNewReqProject("");
      setNewReqTask("");
      setNewReqSubTask("");
      setNewReqPriority("");
      setNewReqPurchaseType("Permanently");
      setNewReqJustification("");
      setSidebarMode(null);
      setStockPanelMode(null);
      setIsSubmitting(false);
    }, 800);
  };

  const handleDeleteSelectedAssets = () => {
    if (selectedAssets.length === 0) return;
    if (window.confirm(`Are you sure you want to delete ${selectedAssets.length} asset(s)?`)) {
      setAssets(assets.filter(a => !selectedAssets.includes(a.id)));
      setSelectedAssets([]);
      toast.success("Deleted successfully!");
    }
  };

  const handleDeleteSelectedRequests = () => {
    if (selectedRequests.length === 0) return;
    if (window.confirm(`Are you sure you want to delete ${selectedRequests.length} request(s)?`)) {
      setRequests(requests.filter(r => !selectedRequests.includes(r.id)));
      setSelectedRequests([]);
      toast.success("Deleted successfully!");
    }
  };

  const handleAddStockSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedAssetForDetail) return;
    
    // Validate each form item
    for (const item of stockFormItems) {
      if (!item.serialNo.trim()) {
        toast.error("Serial No is required");
        return;
      }
      if (!item.vendor) {
        toast.error("Please select a vendor");
        return;
      }
      if (!item.specification.trim()) {
        toast.error("Specification is required");
        return;
      }
    }

    setIsSubmitting(true);
    setTimeout(() => {
      const currentAssetId = selectedAssetForDetail.id;
      const existingStocks = stocks[currentAssetId] || [];
      const newItems: StockItem[] = stockFormItems.map((item, index) => {
        // Evaluate Warranty Status based on date comparison
        let warrantyVal: "In Warranty" | "Expired" = "In Warranty";
        if (item.warrantyDate) {
          const wDate = new Date(item.warrantyDate);
          if (wDate < new Date()) {
            warrantyVal = "Expired";
          }
        }
        return {
          id: `STK#${currentAssetId.replace("ASS#", "")}-${existingStocks.length + index + 101}`,
          serialNo: item.serialNo.trim(),
          companyName: item.companyName.trim() || "-",
          assetValue: item.assetValue.trim() || "-",
          vendor: item.vendor,
          purchaseDate: item.purchaseDate || "-",
          warrantyDate: item.warrantyDate || "-",
          insuranceStartDate: item.insuranceStartDate || "-",
          insuranceEndDate: item.insuranceEndDate || "-",
          insurancePremium: item.insurancePremium || "-",
          modelNumber: item.modelNumber || "-",
          location: item.location || "-",
          department: item.department || "-",
          specification: item.specification.trim(),
          status: "Available", // Default to Available
          warrantyStatus: warrantyVal,
          createdAt: new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " " + new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }),
          updatedAt: new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " " + new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
        };
      });

      setStocks(prev => ({
        ...prev,
        [currentAssetId]: [...existingStocks, ...newItems]
      }));

      // Update assets total/available count if applicable
      setAssets(prev => prev.map(a => {
        if (a.id === currentAssetId) {
          const totalStockCount = existingStocks.length + newItems.length;
          return {
            ...a,
            totalStock: totalStockCount,
            availableStock: a.availableStock + newItems.length
          };
        }
        return a;
      }));

      toast.success("Stock items saved successfully!");
      
      // Reset form items
      setStockFormItems([
        {
          serialNo: "",
          vendor: "",
          companyName: "",
          assetValue: "",
          purchaseDate: "",
          warrantyDate: "",
          insuranceStartDate: "",
          insuranceEndDate: "",
          insurancePremium: "",
          modelNumber: "",
          location: "",
          department: "",
          specification: "",
          attachmentName: ""
        }
      ]);
      setSidebarMode(null);
      setStockPanelMode(null);
      setIsSubmitting(false);
    }, 800);
  };

  // Sidebar Layout for Import Data
  const renderImportSidebar = (title: string, columnsHint: string) => (
    <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-200 font-sans">
      <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
        <h2 className="text-lg font-bold text-[#212121]">{title}</h2>
        <button
          onClick={() => setSidebarMode(null)}
          className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"
        >
          <IconX size={18} />
        </button>
      </div>
      <div className="p-6 bg-white space-y-6 max-h-[calc(100vh-160px)] overflow-y-auto text-left">
        <div className="p-4 rounded-xl border border-blue-100 bg-blue-50/50 flex flex-col gap-1 text-xs">
          <div className="font-bold text-slate-800">
            Before uploading the sheet, please ensure that the following fields are included:
          </div>
          <div className="text-gray-500 font-medium mt-1 leading-relaxed">
            Headers must match exactly. Missing or incorrect columns will raise validation errors.
            <span 
              className="text-blue-500 hover:underline font-bold ml-1.5 cursor-pointer" 
              onClick={() => toast(`Required columns: ${columnsHint}`)}
            >
              Show columns
            </span>
          </div>
        </div>

        <div className="p-4 rounded-xl border border-gray-150 bg-slate-50 flex items-center justify-between gap-4">
          <div className="text-xs text-left">
            <div className="font-bold text-slate-800">Need a sample file?</div>
            <div className="text-gray-400 font-medium mt-0.5 leading-relaxed">Download template sheet and format your dataset.</div>
          </div>
          <button
            onClick={() => toast.success("Sample template downloaded")}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-50 text-xs font-bold text-slate-700 transition cursor-pointer shrink-0 shadow-sm"
          >
            <IconDownload size={14} className="text-gray-450" />
            Sample File
          </button>
        </div>

        <div className="border-2 border-dashed border-gray-200 hover:border-[#FBD037] transition rounded-2xl p-8 flex flex-col items-center justify-center gap-2 cursor-pointer bg-slate-50/20 relative">
          <input
            type="file"
            accept=".xlsx,.xls,.xlsm"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) toast.success(`Selected file: ${file.name}`);
            }}
            className="absolute inset-0 opacity-0 cursor-pointer"
          />
          <IconUpload size={28} className="text-gray-400" />
          <div className="text-xs font-bold text-slate-800 text-center">Click or drag Excel template here</div>
          <button className="mt-1 px-3.5 py-1.5 rounded-lg bg-slate-100 hover:bg-slate-200/80 text-[10px] font-black uppercase text-slate-600 transition tracking-wide">
            Choose file
          </button>
          <div className="text-[10px] text-gray-400 mt-1">Allowed: .xlsx, .xls, .xlsm • Max 20 MB</div>
        </div>

        <div className="pt-4 flex justify-end gap-2.5 border-t border-slate-100 font-bold font-sans">
          <button
            onClick={() => setSidebarMode(null)}
            className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-750 transition cursor-pointer bg-white"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              setSidebarMode(null);
              toast.success("Excel data editor opened");
            }}
            className="px-5 py-2 rounded-xl text-xs font-bold shadow-sm bg-[#64748B] hover:bg-[#475569] text-white transition cursor-pointer border-none"
          >
            Open Editor
          </button>
        </div>
      </div>
    </div>
  );

  const sidebarContent = useMemo(() => {
    if (!sidebarMode) return null;
    
    // Close Back Action
    const handleCloseBack = () => {
      if (backMode) {
        setSidebarMode(backMode);
        setBackMode(null);
      } else {
        setSidebarMode(null);
      }
    };

    if (sidebarMode === "IMPORT_ASSET") {
      return renderImportSidebar("Import Asset Inventory", "Asset Name, Asset Type, Total Stock, Available Stock");
    }

    // IMPORT_STOCK, FILTER_STOCK, ADD_STOCK are now handled inline next to the table
    
    if (sidebarMode === "IMPORT_REQUEST") {
      return renderImportSidebar("Import Requisition Sheets", "Request No, Asset, Project, Task, Quantity, Remarks");
    }

    if (sidebarMode === "ADD_ASSET" || sidebarMode === "EDIT_ASSET") {
      const isEdit = sidebarMode === "EDIT_ASSET";
      return (
        <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-200 font-sans">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
            <h2 className="text-lg font-bold text-[#212121]">{isEdit ? "Update Asset" : "Add New Asset"}</h2>
            <button
              type="button"
              onClick={handleCloseBack}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer animate-in fade-in"
            >
              <IconX size={18} />
            </button>
          </div>
          <form onSubmit={handleAddAssetSubmit} className="bg-white p-6 max-h-[calc(100vh-160px)] overflow-y-auto space-y-5 text-left font-semibold text-gray-700 font-sans">
            <div className="space-y-4">
              <div>
                <span className="text-[11px] font-extrabold text-[#131327] block mb-2 uppercase tracking-wide">Asset Info :</span>
                <div className="space-y-3">
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Asset Name *</label>
                    <input
                      type="text"
                      value={newAssetName}
                      onChange={e => setNewAssetName(e.target.value)}
                      className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                      placeholder="eg.computer/mobile etc."
                      required
                    />
                  </div>
                  <div className="space-y-1.5">
                    <label className="block text-xs font-bold text-[#1E293B]">Asset Type *</label>
                    <div className="flex gap-2">
                      <select
                        value={newAssetType}
                        onChange={e => setNewAssetType(e.target.value)}
                        className="w-full flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                        required
                      >
                        {assetTypes.map(t => (
                          <option key={t.name} value={t.name}>{t.name}</option>
                        ))}
                      </select>
                      <button
                        type="button"
                        onClick={() => {
                          setBackMode(sidebarMode);
                          setSidebarMode("ASSET_TYPE");
                        }}
                        className="px-3.5 bg-black hover:bg-slate-900 text-[#FBD037] rounded-xl flex items-center justify-center font-bold text-sm shadow-sm transition-all cursor-pointer border-none"
                      >
                        <IconPlus size={16} stroke={3} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Description</label>
                <textarea
                  value={newAssetDesc}
                  onChange={e => setNewAssetDesc(e.target.value)}
                  placeholder="Add a brief description..."
                  rows={4}
                  className="w-full px-4 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] resize-none"
                />
              </div>

              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Asset Picture</label>
                <div className="border border-dashed border-gray-200 hover:border-[#FBD037] transition rounded-2xl p-4 flex flex-col items-center justify-center gap-1 cursor-pointer bg-slate-50/10 relative">
                  <input
                    type="file"
                    onChange={(e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        setNewAssetFile(file);
                        setNewAssetFileName(file.name);
                      }
                    }}
                    className="absolute inset-0 opacity-0 cursor-pointer"
                  />
                  <IconUpload size={20} className="text-gray-400" />
                  <span className="text-xs font-bold text-slate-700 text-center leading-normal">
                    {newAssetFileName || "Drag & drop or click to browse"}
                  </span>
                  <span className="text-[9px] text-gray-400 mt-0.5">Maximum 1 file • Max 3MB</span>
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100 font-bold">
              <button
                type="button"
                onClick={handleCloseBack}
                className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-700 transition cursor-pointer bg-white"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-4 py-2 bg-black text-[#FBD037] hover:bg-slate-900 text-xs font-bold rounded-xl transition cursor-pointer border-none flex items-center justify-center min-w-max shadow-sm hover:shadow-md duration-150"
              >
                {isSubmitting ? "Saving..." : "Save Asset"}
              </button>
            </div>
          </form>
        </div>
      );
    }

    if (sidebarMode === "ASSET_TYPE") {
      return (
        <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-200 font-sans">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
            <h2 className="text-lg font-bold text-[#212121]">Asset Type</h2>
            <button 
              type="button"
              onClick={handleCloseBack}
              className="p-1 rounded-lg hover:bg-gray-100 transition text-gray-400 hover:text-gray-650 cursor-pointer animate-in fade-in"
            >
              <IconX size={18} />
            </button>
          </div>

          <div className="p-6 space-y-5 text-left font-sans max-h-[calc(100vh-160px)] overflow-y-auto">
            <div className="space-y-1.5 font-semibold text-gray-700">
              <label className="block text-xs font-bold text-[#1E293B]">Name *</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={newAssetTypeName}
                  onChange={e => setNewAssetTypeName(e.target.value)}
                  className="flex-1 px-4 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                  placeholder="Enter name of asset type"
                />
                <button
                  type="button"
                  onClick={() => {
                    if (!newAssetTypeName.trim()) {
                      toast.error("Name is required");
                      return;
                    }
                    const cleanName = newAssetTypeName.trim();
                    if (editingAssetTypeIdx !== null) {
                      setAssetTypes(prev => {
                        const next = [...prev];
                        next[editingAssetTypeIdx] = { ...next[editingAssetTypeIdx], name: cleanName };
                        return next;
                      });
                      toast.success("Asset type updated successfully!");
                      setEditingAssetTypeIdx(null);
                    } else {
                      if (assetTypes.some(t => t.name.toLowerCase() === cleanName.toLowerCase())) {
                        toast.error("Asset type already exists");
                        return;
                      }
                      setAssetTypes(prev => [...prev, { name: cleanName, isDefault: false, isConstruction: false }]);
                      toast.success("Asset type saved successfully!");
                    }
                    setNewAssetTypeName("");
                  }}
                  className="px-4 py-2 bg-black hover:bg-slate-900 text-white hover:text-[#FBD037] rounded-xl flex items-center justify-center gap-1.5 font-bold text-xs shadow-sm transition cursor-pointer border-none"
                >
                  <IconDeviceFloppy size={14} /> Save
                </button>
              </div>
            </div>

            {/* Asset Types table list */}
            <div className="border border-gray-100 rounded-2xl overflow-hidden shadow-xs">
              <table className="w-full text-xs text-left border-collapse">
                <thead>
                  <tr className="bg-slate-50/60 border-b border-gray-150 font-semibold text-[#131327]/70 text-[11px] uppercase">
                    <th className="p-3 w-16">Sr</th>
                    <th className="p-3">Name</th>
                    <th className="p-3 w-28 text-center">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 font-semibold text-gray-700">
                  {assetTypes.map((type, idx) => (
                    <tr key={type.name} className="hover:bg-slate-50 transition-colors">
                      <td className="p-3 font-mono text-gray-400">{idx + 1}</td>
                      <td className="p-3 font-bold text-gray-800">{type.name}</td>
                      <td className="p-3 flex justify-center gap-2">
                        <button
                          type="button"
                          onClick={() => {
                            setEditingAssetTypeIdx(idx);
                            setNewAssetTypeName(type.name);
                          }}
                          className="p-1 rounded border border-gray-200 bg-white hover:bg-slate-50 text-slate-700 cursor-pointer shadow-xs"
                          title="Edit"
                        >
                          <IconEdit size={13} />
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            if (window.confirm(`Are you sure you want to delete "${type.name}" type?`)) {
                              setAssetTypes(prev => prev.filter((_, i) => i !== idx));
                              toast.success("Asset type deleted successfully");
                              if (editingAssetTypeIdx === idx) {
                               setEditingAssetTypeIdx(null);
                               setNewAssetTypeName("");
                              }
                            }
                          }}
                          className="p-1 rounded border border-gray-200 bg-white hover:bg-rose-50 text-rose-600 cursor-pointer shadow-xs border-none"
                          title="Delete"
                        >
                          <IconTrash size={13} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="pt-2 flex justify-end font-bold border-t border-slate-100">
              <button
                type="button"
                onClick={handleCloseBack}
                className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-750 transition cursor-pointer bg-white"
              >
                Back
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (sidebarMode === "ADD_REQUEST") {
      return (
        <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-200 font-sans">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
            <h2 className="text-lg font-bold text-[#212121]">Add Requisition</h2>
            <button
              onClick={() => setSidebarMode(null)}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"
            >
              <IconX size={18} />
            </button>
          </div>
          <form onSubmit={handleAddRequestSubmit} className="bg-white p-6 max-h-[calc(100vh-160px)] overflow-y-auto space-y-4 text-left font-semibold text-gray-700 font-sans font-semibold">
            <div className="space-y-3.5">
              
              {/* Request Type */}
              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Request Type *</label>
                <select
                  value={newReqType}
                  onChange={e => setNewReqType(e.target.value)}
                  className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                  required
                >
                  <option value="Stock Request">Stock Request</option>
                  <option value="Project Asset Request">Project Asset Request</option>
                  <option value="Emp Asset Request">Emp Asset Request</option>
                </select>
              </div>

              {/* Asset Name with + button */}
              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Asset Name *</label>
                <div className="flex gap-2">
                  <select
                    value={newReqAsset}
                    onChange={e => setNewReqAsset(e.target.value)}
                    className="w-full flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                    required
                  >
                    <option value="">Select Asset...</option>
                    {assets.map(a => (
                      <option key={a.id} value={a.name}>{a.name}</option>
                    ))}
                  </select>
                  <button
                    type="button"
                    onClick={() => {
                      setBackMode("ADD_REQUEST");
                      setSidebarMode("ADD_ASSET");
                    }}
                    className="px-3.5 bg-black hover:bg-slate-900 text-[#FBD037] rounded-xl flex items-center justify-center font-bold text-sm shadow-sm transition cursor-pointer border-none"
                  >
                    <IconPlus size={16} stroke={3} />
                  </button>
                </div>
              </div>

              {/* Asset Type with + button */}
              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Asset Type *</label>
                <div className="flex gap-2">
                  <select
                    value={newReqAssetType}
                    onChange={e => setNewReqAssetType(e.target.value)}
                    className="w-full flex-1 px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                    required
                  >
                    <option value="">Select Asset Type...</option>
                    {assetTypes.map(t => (
                      <option key={t.name} value={t.name}>{t.name}</option>
                    ))}
                  </select>
                  <button
                    type="button"
                    onClick={() => {
                      setBackMode("ADD_REQUEST");
                      setSidebarMode("ASSET_TYPE");
                    }}
                    className="px-3.5 bg-black hover:bg-slate-900 text-[#FBD037] rounded-xl flex items-center justify-center font-bold text-sm shadow-sm transition cursor-pointer border-none"
                  >
                    <IconPlus size={16} stroke={3} />
                  </button>
                </div>
              </div>

              {/* Quantity & Project */}
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Quantity *</label>
                  <input
                    type="number"
                    value={newReqQty}
                    onChange={e => setNewReqQty(e.target.value)}
                    className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                    placeholder="Enter Quantity"
                    required
                  />
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Project</label>
                  <select
                    value={newReqProject}
                    onChange={e => setNewReqProject(e.target.value)}
                    className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                  >
                    <option value="">Select Project</option>
                    {projects.map(p => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Task & Sub Task */}
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Task</label>
                  <select
                    value={newReqTask}
                    onChange={e => setNewReqTask(e.target.value)}
                    className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                  >
                    <option value="">Select Task</option>
                    {tasks.map(t => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </select>
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Sub Task</label>
                  <select
                    value={newReqSubTask}
                    onChange={e => setNewReqSubTask(e.target.value)}
                    className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                  >
                    <option value="">Select Sub Task</option>
                    {subTasks.map(st => (
                      <option key={st} value={st}>{st}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Priority & Purchase Type */}
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Priority *</label>
                  <select
                    value={newReqPriority}
                    onChange={e => setNewReqPriority(e.target.value)}
                    className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                    required
                  >
                    <option value="">Select Priority</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                </div>
                <div className="space-y-1.5">
                  <label className="block text-xs font-bold text-[#1E293B]">Purchase Type *</label>
                  <select
                    value={newReqPurchaseType}
                    onChange={e => setNewReqPurchaseType(e.target.value)}
                    className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
                    required
                  >
                    <option value="Permanently">Permanently</option>
                    <option value="Temporarily">Temporarily</option>
                  </select>
                </div>
              </div>

              {/* Justification */}
              <div className="space-y-1.5">
                <label className="block text-xs font-bold text-[#1E293B]">Justification *</label>
                <textarea
                  value={newReqJustification}
                  onChange={e => setNewReqJustification(e.target.value)}
                  placeholder="Enter justification for this asset request..."
                  rows={4}
                  className="w-full px-4 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] resize-none"
                  required
                />
              </div>

            </div>

            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100 font-bold">
              <button
                type="button"
                onClick={() => setSidebarMode(null)}
                className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-700 transition cursor-pointer bg-white"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-4 py-2 bg-black text-[#FBD037] hover:bg-slate-900 text-xs font-bold rounded-xl transition cursor-pointer border-none flex items-center justify-center min-w-max shadow-sm hover:shadow-md duration-150"
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      );
    }

    if (sidebarMode === "FILTER_REQUEST") {
      return (
        <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-200 font-sans">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
            <h2 className="text-lg font-bold text-[#212121]">Filter Requisitions</h2>
            <button
              onClick={() => setSidebarMode(null)}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"
            >
              <IconX size={18} />
            </button>
          </div>
          <div className="p-6 bg-white space-y-4 text-left font-semibold text-gray-700 font-sans">
            <div className="space-y-1.5">
              <label className="block text-xs font-bold text-[#1E293B]">Select Status</label>
              <select
                value={statusFilter}
                onChange={e => setStatusFilter(e.target.value)}
                className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
              >
                <option value="All">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="Received">Received</option>
                <option value="Scheduled">Scheduled</option>
                <option value="Not Received">Not Received</option>
              </select>
            </div>

            <div className="space-y-1.5">
              <label className="block text-xs font-bold text-[#1E293B]">Select Request Type</label>
              <select
                value={reqTypeFilter}
                onChange={e => setReqTypeFilter(e.target.value)}
                className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer"
              >
                <option value="All">Select Request Type</option>
                <option value="Stock Request">Stock Request</option>
                <option value="Project Asset Request">Project Asset Request</option>
                <option value="Emp Asset Request">Emp Asset Request</option>
              </select>
            </div>

            <div className="pt-4 border-t border-slate-100 flex gap-2 justify-end font-bold">
              <button
                onClick={() => {
                  setStatusFilter("All");
                  setReqTypeFilter("All");
                  toast.success("Filters cleared");
                  setSidebarMode(null);
                }}
                className="px-4 py-2 border border-gray-200 hover:bg-gray-50 text-slate-700 rounded-xl text-xs font-bold transition cursor-pointer bg-white"
              >
                Clear
              </button>
              <button
                onClick={() => setSidebarMode(null)}
                className="px-5 py-2 bg-black text-[#FBD037] hover:bg-slate-900 text-xs font-bold rounded-xl transition cursor-pointer border-none shadow-sm"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (sidebarMode === "VIEW_REQUEST" && selectedReqForView) {
      const statusColors: Record<string, string> = {
        Pending: "bg-amber-100 text-amber-800 border-amber-250",
        Received: "bg-emerald-100 text-emerald-800 border-amber-250",
        Scheduled: "bg-orange-100 text-orange-850 border-amber-255",
        "Not Received": "bg-rose-100 text-rose-800 border-amber-255"
      };
      return (
        <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-200 font-sans">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
            <h2 className="text-lg font-bold text-[#212121]">Asset Request Details</h2>
            <button
              onClick={() => {
                setSidebarMode(null);
                setSelectedReqForView(null);
              }}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"
            >
              <IconX size={18} />
            </button>
          </div>
          <div className="p-6 bg-white space-y-5 text-left font-sans text-xs font-semibold text-slate-700 max-h-[calc(100vh-160px)] overflow-y-auto">
            
            {/* Grid of Request Parameters */}
            <div className="grid grid-cols-2 gap-y-4 gap-x-2.5">
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Request ID</span>
                <strong className="text-sm text-slate-950 font-mono font-bold leading-relaxed">{selectedReqForView.id}</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Type</span>
                <strong className="text-sm text-slate-950 leading-relaxed">{selectedReqForView.type}</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Status</span>
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-[9px] font-extrabold border mt-1 ${statusColors[selectedReqForView.status]}`}>
                  {selectedReqForView.status}
                </span>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Requested By</span>
                <strong className="text-sm text-slate-950 leading-relaxed">{selectedReqForView.requestedBy === "YK" ? "Yash Koladiya" : "D"}</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Asset Name</span>
                <strong className="text-slate-850 font-bold leading-relaxed">{selectedReqForView.asset}</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Project Name</span>
                <strong className="text-slate-850 font-bold leading-relaxed">{selectedReqForView.project}</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Task Name</span>
                <strong className="text-slate-850 font-bold leading-relaxed">{selectedReqForView.task}</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Sub Task Name</span>
                <strong className="text-slate-850 font-bold leading-relaxed">{selectedReqForView.subTask}</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Asset Type</span>
                <strong className="text-slate-850 font-bold leading-relaxed">Display</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Quantity</span>
                <strong className="text-slate-850 font-bold leading-relaxed font-mono">{selectedReqForView.quantity}</strong>
              </div>
              <div>
                <span className="text-[10px] text-gray-400 block font-bold uppercase">Accepted Quantity</span>
                <strong className="text-slate-850 font-bold leading-relaxed">{selectedReqForView.acceptedQuantity}</strong>
              </div>
            </div>

            {/* Remarks */}
            <div className="pt-2.5">
              <span className="text-[10px] text-gray-400 block font-bold uppercase mb-1">Remarks</span>
              <div className="p-3 bg-slate-50 border border-slate-100 rounded-xl font-medium text-slate-800 leading-normal">
                {selectedReqForView.remarks}
              </div>
            </div>

            {/* Activity Timeline section matching Screenshot 2 */}
            <div className="pt-4 border-t border-slate-100 space-y-3">
              <span className="text-[10px] text-gray-400 block font-bold uppercase tracking-wider">Activity Timeline</span>
              
              <div className="flex gap-4 items-start pl-2">
                <div className="flex flex-col items-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-amber-500 shadow-sm mt-1.5" />
                  <div className="w-0.5 h-10 bg-slate-100 mt-1" />
                </div>
                <div className="flex-1 flex justify-between items-start">
                  <div>
                    <strong className="text-slate-900 block text-xs">Pending</strong>
                    <span className="text-[10px] text-gray-400 font-medium block mt-0.5">Asset request has been created.</span>
                  </div>
                  <span className="text-[9px] text-gray-400 font-mono shrink-0">{selectedReqForView.createdAt}</span>
                </div>
              </div>
            </div>

            <div className="pt-4 border-t border-slate-100 flex justify-end font-bold">
              <button
                onClick={() => {
                  setSidebarMode(null);
                  setSelectedReqForView(null);
                }}
                className="px-5 py-2 border border-gray-200 hover:bg-gray-50 text-slate-700 rounded-xl text-xs font-bold transition cursor-pointer bg-white"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (sidebarMode === "DELETE_REQUEST_CONFIRM" && selectedReqForDelete) {
      return (
        <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-200 font-sans">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-150 bg-white">
            <h2 className="text-lg font-bold text-[#212121]">Remove Request</h2>
            <button
              onClick={() => {
                setSidebarMode(null);
                setSelectedReqForDelete(null);
              }}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"
            >
              <IconX size={18} />
            </button>
          </div>
          <div className="p-6 bg-white space-y-6 text-center font-semibold">
            
            <div className="py-4">
              <div className="text-sm font-bold text-slate-800">Remove Request</div>
              <p className="text-xs text-gray-400 mt-1.5 font-semibold">Are you sure you want to remove this request?</p>
            </div>

            <div className="flex justify-center gap-3 font-bold">
              <button
                onClick={() => {
                  setSidebarMode(null);
                  setSelectedReqForDelete(null);
                }}
                className="px-5 py-2 border border-gray-200 hover:bg-gray-50 text-slate-750 rounded-xl text-xs font-bold transition cursor-pointer bg-white"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setRequests(prev => prev.filter(r => r.id !== selectedReqForDelete.id));
                  toast.success("Request removed successfully!");
                  setSidebarMode(null);
                  setSelectedReqForDelete(null);
                }}
                className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl text-xs font-bold transition cursor-pointer border-none shadow-sm hover:shadow-md"
              >
                Remove
              </button>
            </div>

          </div>
        </div>
      );
    }

    if (sidebarMode === "DELETE_ASSET_CONFIRM" && selectedAssetForDelete) {
      return (
        <div className="flex flex-col bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden animate-in slide-in-from-right duration-200 font-sans">
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-150 bg-white">
            <h2 className="text-lg font-bold text-[#212121]">Delete Asset</h2>
            <button
              onClick={() => {
                setSidebarMode(null);
                setSelectedAssetForDelete(null);
              }}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"
            >
              <IconX size={18} />
            </button>
          </div>
          <div className="p-6 bg-white space-y-6 text-center font-semibold">
            
            <div className="py-4">
              <div className="text-sm font-bold text-slate-800">Delete Asset</div>
              <p className="text-xs text-gray-400 mt-1.5 font-semibold">Are you sure you want to delete this Asset?</p>
            </div>

            <div className="flex justify-center gap-3 font-bold">
              <button
                onClick={() => {
                  setSidebarMode(null);
                  setSelectedAssetForDelete(null);
                }}
                className="px-5 py-2 border border-gray-200 hover:bg-gray-50 text-slate-750 rounded-xl text-xs font-bold transition cursor-pointer bg-white"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setAssets(prev => prev.filter(a => a.id !== selectedAssetForDelete.id));
                  toast.success("Asset deleted successfully!");
                  setSidebarMode(null);
                  setSelectedAssetForDelete(null);
                  setSelectedAssetForDetail(null);
                }}
                className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl text-xs font-bold transition cursor-pointer border-none shadow-sm"
              >
                Delete
              </button>
            </div>

          </div>
        </div>
      );
    }



    return null;
  }, [sidebarMode, backMode, newAssetName, newAssetType, newAssetDesc, newAssetFileName, isSubmitting, newReqType, newReqAsset, newReqAssetType, newReqQty, newReqProject, newReqTask, newReqSubTask, newReqPriority, newReqPurchaseType, newReqJustification, assets, assetTypes, projects, tasks, subTasks, statusFilter, reqTypeFilter, selectedReqForView, selectedReqForDelete, selectedAssetForEdit, selectedAssetForDelete, selectedAssetForDetail, stockFormItems, vendors, departments, stockStatusFilter, stockWarrantyFilter]);

  return (
    <div className="w-full mx-auto mt-2 animate-in fade-in duration-300 relative">
      {isSettingPageOpen ? (
        // RENDER ASSET SETTINGS SECTION
        <div className="space-y-6 font-sans">
          {/* Breadcrumbs / Settings Header */}
          <div className="flex flex-col items-start mb-6 gap-1.5 px-2 text-left">
            <div className="flex items-center gap-1.5 text-xs font-semibold text-gray-500">
              <span className="hover:text-gray-800 cursor-pointer" onClick={() => setIsSettingPageOpen(false)}>Dashboard</span>
              <IconChevronRight size={12} className="text-gray-400" />
              <span className="hover:text-gray-800 cursor-pointer" onClick={() => setIsSettingPageOpen(false)}>Asset</span>
              <IconChevronRight size={12} className="text-gray-400" />
              <strong className="text-gray-800 font-bold">Asset Setting</strong>
            </div>
            <div className="flex justify-between items-center w-full mt-2">
              <h1 className="text-2xl font-extrabold text-[#1E293B] tracking-tight">Asset Settings</h1>
              <button 
                onClick={() => setIsSettingPageOpen(false)}
                className="px-4 py-2 border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 rounded-xl text-xs font-bold transition cursor-pointer shadow-xs"
              >
                Back to Dashboard
              </button>
            </div>
          </div>

          {/* Settings Tabs Selector */}
          <div className="flex items-start mb-6 px-2">
            <div className="inline-flex rounded-t-lg rounded-tr-[20px] bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 py-0.5 px-1 space-x-2 overflow-x-auto hide-scrollbar max-w-full relative shadow-sm border border-slate-200/40">
              <div className="absolute inset-0 rounded-[inherit] bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
              <button
                onClick={() => setSettingsTab("code")}
                className={`px-4 py-2 text-sm rounded-lg whitespace-nowrap transition-colors duration-200 cursor-pointer font-bold ${
                  settingsTab === "code"
                    ? "bg-[#000] text-[#FFFFFF] shadow-sm z-10"
                    : "bg-transparent text-[#212121]/70 z-10"
                }`}
              >
                Unique Identify Code
              </button>
              <button
                onClick={() => setSettingsTab("type")}
                className={`px-4 py-2 text-sm rounded-lg whitespace-nowrap transition-colors duration-200 cursor-pointer font-bold ${
                  settingsTab === "type"
                    ? "bg-[#000] text-[#FFFFFF] shadow-sm z-10"
                    : "bg-transparent text-[#212121]/70 z-10"
                }`}
              >
                Asset Type
              </button>
            </div>
          </div>

          {/* Settings Content Area */}
          {settingsTab === "code" ? (
            // UNIQUE IDENTIFY CODE TAB
            <div className="bg-white rounded-3xl border border-slate-100 shadow-xs p-6 space-y-6 text-left">
              <div className="flex justify-between items-center mb-6 border-b border-slate-100 pb-4">
                <h2 className="text-lg font-bold text-slate-900">Unique Identify Code Settings</h2>
                {isCodeSettingsLoading && (
                  <span className="text-xs text-slate-400 font-medium animate-pulse">Loading settings...</span>
                )}
              </div>
              
              <div className="space-y-5">
                {[
                  { key: "asset", label: "Asset" },
                  { key: "stock", label: "Asset Stock" },
                  { key: "request", label: "Asset Request" },
                  { key: "maintenance", label: "Asset Maintenance" },
                  { key: "insurance", label: "Asset Insurance & Warranty Tracking" },
                  { key: "depreciation", label: "Asset Depreciation" },
                  { key: "allocation", label: "Asset Allocation Usage Tracking" },
                ].map(({ key, label }) => {
                  const setting = codeSettings[key] || { seriesCode: "null", connector: "null", sequenceLength: 3 };
                  return (
                    <div key={key} className="p-5 border border-slate-150 rounded-2xl relative bg-slate-50/20">
                      <span className="absolute -top-2.5 left-4 px-2 bg-white text-[10px] font-black text-slate-500 uppercase tracking-wider">
                        {label}
                      </span>
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-2">
                        <div className="space-y-1.5">
                          <label className="block text-xs font-bold text-[#1E293B]">Series Code</label>
                          <input
                            type="text"
                            value={setting.seriesCode}
                            onChange={e => {
                              const val = e.target.value;
                              setCodeSettings(prev => ({
                                ...prev,
                                [key]: { ...prev[key], seriesCode: val }
                              }));
                            }}
                            className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                            placeholder="e.g. ASS"
                          />
                        </div>
                        <div className="space-y-1.5">
                          <label className="block text-xs font-bold text-[#1E293B]">Connector</label>
                          <input
                            type="text"
                            value={setting.connector}
                            onChange={e => {
                              const val = e.target.value;
                              setCodeSettings(prev => ({
                                ...prev,
                                [key]: { ...prev[key], connector: val }
                              }));
                            }}
                            className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                            placeholder="e.g. #"
                          />
                        </div>
                        <div className="space-y-1.5">
                          <label className="block text-xs font-bold text-[#1E293B]">Sequence Length</label>
                          <input
                            type="number"
                            value={setting.sequenceLength}
                            onChange={e => {
                              const val = Number(e.target.value);
                              setCodeSettings(prev => ({
                                ...prev,
                                [key]: { ...prev[key], sequenceLength: val }
                              }));
                            }}
                            className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]"
                            placeholder="Ex. 3 → 001"
                            min={1}
                            max={10}
                          />
                        </div>
                        <div className="space-y-1.5">
                          <label className="block text-xs font-bold text-slate-400">Preview</label>
                          <div className="w-full px-3 py-2 bg-slate-50 border border-slate-200/60 rounded-xl text-xs font-bold text-slate-500 h-9 flex items-center select-none">
                            {getCodePreview(setting.seriesCode, setting.connector, setting.sequenceLength) || "null"}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex justify-end pt-4 border-t border-slate-100">
                <button
                  onClick={handleSaveSettings}
                  disabled={isCodeSettingsSaving || isCodeSettingsLoading}
                  className="bg-black hover:bg-slate-900 text-[#FBD037] px-6 py-2.5 rounded-xl font-bold text-xs shadow-sm transition cursor-pointer border-none disabled:opacity-50"
                >
                  {isCodeSettingsSaving ? "Saving..." : "Save Settings"}
                </button>
              </div>
            </div>
          ) : (
            // ASSET TYPE TAB
            <div className="bg-white rounded-3xl border border-slate-100 shadow-xs p-6 text-left space-y-4">
              <h2 className="text-xl font-extrabold text-slate-900 leading-tight">Asset Types</h2>
              
              {/* Asset Type Toolbar */}
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 bg-slate-50/10 py-1">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={assetTypeSearchQuery}
                    onChange={e => { setAssetTypeSearchQuery(e.target.value); setAssetTypePage(1); }}
                    className="pl-3 pr-4 h-8 text-xs rounded-lg border border-slate-200 bg-white outline-none focus:ring-1 focus:ring-[#FBD037] font-semibold w-48"
                  />
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => {
                      setNewSettingTypeName("");
                      setNewSettingTypeIsConstruction(false);
                      setNewSettingTypeNameError("");
                      setSettingsTypeModalMode("ADD_TYPE");
                    }}
                    className="bg-black hover:bg-slate-900 text-white px-3.5 h-8 rounded-lg flex items-center gap-1 text-xs font-bold cursor-pointer border-none shadow-xs transition"
                  >
                    <IconPlus size={14} /> Add Asset Type
                  </button>
                  <button 
                    onClick={() => { loadAssetTypes(); toast.success("Asset types list refreshed"); }}
                    className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition shadow-xs cursor-pointer"
                  >
                    <IconRefresh size={14} />
                  </button>
                </div>
              </div>

              {/* Asset Types list table */}
              <div className="pb-2 overflow-x-auto">
                <table className="w-full text-xs text-left border-collapse min-w-[600px]">
                  <thead>
                    <tr className="bg-[#F8FAFC]/60 border-b border-slate-200/80 font-semibold text-[#131327]/70 text-[11px] tracking-wider uppercase">
                      <th className="py-4 px-4 w-20">SR NO.</th>
                      <th className="py-4 px-4">NAME</th>
                      <th className="py-4 px-4 text-center w-28">ACTION</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100 text-xs text-slate-700">
                    {isAssetTypesLoading ? (
                      <tr>
                        <td colSpan={3} className="py-10 text-center text-slate-400 font-semibold animate-pulse">
                          Loading asset types...
                        </td>
                      </tr>
                    ) : assetTypes.filter(t => t.name.toLowerCase().includes(assetTypeSearchQuery.toLowerCase())).length === 0 ? (
                      <tr>
                        <td colSpan={3} className="py-10 text-center text-slate-400 font-semibold">
                          No asset types found
                        </td>
                      </tr>
                    ) : (
                      assetTypes
                        .filter(t => t.name.toLowerCase().includes(assetTypeSearchQuery.toLowerCase()))
                        .slice((assetTypePage - 1) * ASSET_TYPE_PAGE_SIZE, assetTypePage * ASSET_TYPE_PAGE_SIZE)
                        .map((type, idx) => (
                        <tr key={type.id || type.name} className="hover:bg-slate-50/50 transition-colors border-b border-slate-100">
                          <td className="py-4 px-4 font-mono text-slate-400 font-semibold">{(assetTypePage - 1) * ASSET_TYPE_PAGE_SIZE + idx + 1}</td>
                          <td className="py-4 px-4 font-bold text-slate-800 flex items-center">
                            {type.name}
                            {type.isDefault && (
                              <span className="ml-2.5 px-2 py-0.5 rounded bg-emerald-50 text-emerald-600 border border-emerald-200 font-extrabold text-[8px] uppercase tracking-wider">
                                Default
                              </span>
                            )}
                          </td>
                          <td className="py-4 px-4">
                            <div className="relative flex justify-center">
                              <button
                                onClick={() => setSettingsTypeActiveActionMenuName(settingsTypeActiveActionMenuName === type.name ? null : type.name)}
                                className="w-7 h-7 rounded-full border border-slate-200 flex items-center justify-center hover:bg-slate-50 text-slate-500 cursor-pointer bg-white transition"
                              >
                                <IconDots size={14} />
                              </button>
                              {settingsTypeActiveActionMenuName === type.name && (
                                <>
                                  <div className="fixed inset-0 z-45" onClick={() => setSettingsTypeActiveActionMenuName(null)} />
                                  <div className="absolute right-0 top-8 z-50 bg-white border border-gray-200 rounded-xl shadow-lg py-1.5 text-left font-sans text-xs font-semibold min-w-[100px]">
                                    <button 
                                      onClick={() => {
                                        setSelectedTypeForSetting(type);
                                        setNewSettingTypeName(type.name);
                                        setNewSettingTypeIsConstruction(type.isConstruction);
                                        setNewSettingTypeNameError("");
                                        setSettingsTypeModalMode("EDIT_TYPE");
                                        setSettingsTypeActiveActionMenuName(null);
                                      }}
                                      className="w-full px-4 py-2 hover:bg-gray-50 transition-colors text-slate-700 text-left border-none bg-transparent cursor-pointer"
                                    >
                                      Edit
                                    </button>
                                    <button 
                                      onClick={() => {
                                        setSelectedTypeForSetting(type);
                                        setSettingsTypeModalMode("DELETE_TYPE");
                                        setSettingsTypeActiveActionMenuName(null);
                                      }}
                                      className="w-full px-4 py-2 hover:bg-rose-50 text-rose-600 transition-colors text-left border-none bg-transparent cursor-pointer"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                        ))
                    )}
                  </tbody>
                </table>

                {/* Pagination Footer */}
                <div className="px-6 py-4 flex items-center justify-between border-t border-slate-100 bg-white font-sans text-xs font-semibold text-slate-500">
                  <div className="flex items-center gap-1">
                    {(() => {
                      const filtered = assetTypes.filter(t => t.name.toLowerCase().includes(assetTypeSearchQuery.toLowerCase()));
                      const total = filtered.length;
                      const start = total === 0 ? 0 : (assetTypePage - 1) * ASSET_TYPE_PAGE_SIZE + 1;
                      const end = Math.min(assetTypePage * ASSET_TYPE_PAGE_SIZE, total);
                      const totalPages = Math.max(1, Math.ceil(total / ASSET_TYPE_PAGE_SIZE));
                      return (
                        <>
                          <span>Record {start}-{end} of {total}</span>
                          <div className="flex items-center gap-2 ml-4">
                            <button
                              disabled={assetTypePage <= 1}
                              onClick={() => setAssetTypePage(p => Math.max(1, p - 1))}
                              className="w-7 h-7 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-slate-50 transition cursor-pointer"
                            >
                              ‹
                            </button>
                            <span className="text-slate-800 font-bold px-1">{assetTypePage} / {totalPages}</span>
                            <button
                              disabled={assetTypePage >= totalPages}
                              onClick={() => setAssetTypePage(p => Math.min(totalPages, p + 1))}
                              className="w-7 h-7 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-slate-50 transition cursor-pointer"
                            >
                              ›
                            </button>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal Overlays for Add, Edit, Delete Asset Type */}
          {settingsTypeModalMode !== null && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-xs font-sans animate-in fade-in duration-200">
              {settingsTypeModalMode === "DELETE_TYPE" ? (
                // DELETE TYPE MODAL (Screenshot 5)
                <div className="bg-white rounded-3xl shadow-xl w-full max-w-sm p-6 text-center space-y-4">
                  <h3 className="text-lg font-bold text-slate-900">Delete Asset Type</h3>
                  <p className="text-xs text-gray-500 leading-relaxed font-semibold">
                    Are you sure you want to delete this Asset Type? This action cannot be undone.
                  </p>
                  <div className="flex justify-end gap-3 pt-2">
                    <button 
                      onClick={() => setSettingsTypeModalMode(null)} 
                      className="px-4 py-2 border border-gray-250 text-slate-700 bg-white hover:bg-gray-50 rounded-xl text-xs font-bold transition cursor-pointer"
                    >
                      Cancel
                    </button>
                    <button 
                      disabled={isAssetTypeSubmitting}
                      onClick={async () => {
                        if (!selectedTypeForSetting) return;
                        const id = selectedTypeForSetting.id;
                        if (!id) {
                          toast.error("Cannot delete: missing asset type ID");
                          return;
                        }
                        setIsAssetTypeSubmitting(true);
                        try {
                          const res = await deleteAssetType(id);
                          if (res.success) {
                            toast.success("Asset type deleted successfully");
                            loadAssetTypes();
                          } else {
                            toast.error(res.message || "Failed to delete asset type");
                          }
                        } catch (err: any) {
                          toast.error(err?.message || "Failed to delete asset type");
                        } finally {
                          setIsAssetTypeSubmitting(false);
                          setSettingsTypeModalMode(null);
                        }
                      }} 
                      className="px-5 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl text-xs font-bold transition border-none cursor-pointer disabled:opacity-60"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ) : (
                // ADD / EDIT TYPE MODAL (Screenshot 3 & 4)
                <div className="bg-white rounded-3xl shadow-xl w-full max-w-md p-6 space-y-4 text-left">
                  <div className="flex items-center justify-between pb-3 border-b border-slate-100">
                    <h3 className="text-lg font-bold text-slate-900">
                      {settingsTypeModalMode === "ADD_TYPE" ? "Add Asset Type" : "Edit Asset Type"}
                    </h3>
                    <button 
                      onClick={() => setSettingsTypeModalMode(null)} 
                      className="p-1 rounded-lg hover:bg-gray-150 text-slate-400 hover:text-slate-600 transition cursor-pointer"
                    >
                      <IconX size={18} />
                    </button>
                  </div>

                  <div className="space-y-4 py-2">
                    <div className="space-y-1.5 font-semibold text-gray-700">
                      <label className="block text-xs font-bold text-[#1E293B]">Name *</label>
                      <input 
                        type="text" 
                        value={newSettingTypeName}
                        onChange={e => {
                          setNewSettingTypeName(e.target.value);
                          if (e.target.value.trim()) setNewSettingTypeNameError("");
                        }}
                        className={`w-full px-3 py-2 bg-white border rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] ${
                          newSettingTypeNameError ? "border-red-500" : "border-gray-200"
                        }`}
                        placeholder="Enter name of asset type" 
                      />
                      {newSettingTypeNameError && (
                        <span className="text-[10px] text-red-500 font-bold block">{newSettingTypeNameError}</span>
                      )}
                    </div>

                    <div className="flex items-center gap-2 pt-1 font-semibold text-gray-700">
                      <input 
                        type="checkbox" 
                        id="is-construction-checkbox"
                        checked={newSettingTypeIsConstruction}
                        onChange={e => setNewSettingTypeIsConstruction(e.target.checked)}
                        className="rounded accent-[#FBD037] w-4 h-4 cursor-pointer" 
                      />
                      <label htmlFor="is-construction-checkbox" className="text-xs text-slate-700 select-none cursor-pointer">
                        Construction Asset Type
                      </label>
                    </div>
                  </div>

                  <div className="flex justify-end gap-3 pt-3 border-t border-slate-100">
                    <button 
                      onClick={() => setSettingsTypeModalMode(null)} 
                      className="px-4 py-2 border border-gray-250 text-slate-700 bg-white hover:bg-gray-50 rounded-xl text-xs font-bold transition cursor-pointer"
                    >
                      Cancel
                    </button>
                    <button 
                      disabled={isAssetTypeSubmitting}
                      onClick={async () => {
                        if (!newSettingTypeName.trim()) {
                          setNewSettingTypeNameError("Name is required");
                          return;
                        }
                        const cleanName = newSettingTypeName.trim();
                        setIsAssetTypeSubmitting(true);
                        try {
                          if (settingsTypeModalMode === "ADD_TYPE") {
                            const res = await createAssetType({
                              name: cleanName,
                              isConstructionAssetType: newSettingTypeIsConstruction,
                            });
                            if (res.success) {
                              toast.success("Asset type created successfully!");
                              loadAssetTypes();
                              setSettingsTypeModalMode(null);
                            } else {
                              toast.error(res.message || "Failed to create asset type");
                            }
                          } else {
                            // EDIT TYPE
                            const id = selectedTypeForSetting?.id;
                            if (!id) {
                              toast.error("Cannot update: missing asset type ID");
                              return;
                            }
                            const res = await updateAssetType(id, {
                              name: cleanName,
                              isConstructionAssetType: newSettingTypeIsConstruction,
                            });
                            if (res.success) {
                              toast.success("Asset type updated successfully!");
                              loadAssetTypes();
                              setSettingsTypeModalMode(null);
                            } else {
                              toast.error(res.message || "Failed to update asset type");
                            }
                          }
                        } catch (err: any) {
                          toast.error(err?.message || "An error occurred");
                        } finally {
                          setIsAssetTypeSubmitting(false);
                        }
                      }} 
                      className="px-5 py-2 bg-black hover:bg-slate-900 text-white rounded-xl text-xs font-bold transition border-none cursor-pointer flex items-center gap-1 shadow-sm disabled:opacity-60"
                    >
                      <IconCheck size={14} /> Save
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}

        </div>
      ) : (
        <>
          {/* Dynamic Header Block (Breadcrumbs vs Main Title) */}
          {selectedAssetForDetail ? (
        <div className="flex flex-col items-start mb-6 gap-1.5 px-2 text-left font-sans">
          <div className="flex items-center gap-1.5 text-xs font-semibold text-gray-500">
            <span className="hover:text-gray-800 cursor-pointer" onClick={() => setSelectedAssetForDetail(null)}>Dashboard</span>
            <IconChevronRight size={12} className="text-gray-400" />
            <span className="hover:text-gray-800 cursor-pointer" onClick={() => setSelectedAssetForDetail(null)}>Assets</span>
            <IconChevronRight size={12} className="text-gray-400" />
            <strong className="text-gray-800 font-bold">{selectedAssetForDetail.name}</strong>
          </div>
          <h1 className="text-2xl font-extrabold text-[#1E293B] tracking-tight">Asset Details</h1>
        </div>
      ) : (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4 px-2 text-left">
          <div>
            <h1 className="text-2xl font-extrabold text-[#1E293B] tracking-tight">Assets Management</h1>
          </div>
          <div className="flex items-center gap-2">
            <button 
              onClick={() => {
                setIsSettingPageOpen(!isSettingPageOpen);
                setSelectedAssetForDetail(null);
              }}
              className={`p-2 border rounded-xl transition shadow-xs cursor-pointer ${
                isSettingPageOpen
                  ? "bg-black text-[#FBD037] border-black"
                  : "bg-white hover:bg-slate-50 border-slate-200 text-slate-700"
              }`}
              title="Asset Settings"
            >
              <IconSettings size={15} />
            </button>
          </div>
        </div>
      )}

      {/* Tabs / Sub-tab selector */}
      {selectedAssetForDetail ? (
        <div className="flex items-start">
          <div className="inline-flex rounded-t-lg rounded-tr-[20px] bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 py-0.5 px-1 space-x-2 overflow-x-auto hide-scrollbar max-w-full relative shadow-sm border border-slate-200/40">
            <div className="absolute inset-0 rounded-[inherit] bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
            <button
              onClick={() => {
                setDetailActiveTab("stock");
                setSidebarMode(null);
              }}
              className={`px-4 py-2 text-sm rounded-lg whitespace-nowrap transition-colors duration-200 cursor-pointer font-bold ${
                detailActiveTab === "stock"
                  ? "bg-[#000] text-[#FFFFFF] shadow-sm z-10"
                  : "bg-transparent text-[#212121]/70 z-10"
              }`}
            >
              Stock Management
            </button>
            <button
              onClick={() => {
                setDetailActiveTab("activity");
                setSidebarMode(null);
              }}
              className={`px-4 py-2 text-sm rounded-lg whitespace-nowrap transition-colors duration-200 cursor-pointer font-bold ${
                detailActiveTab === "activity"
                  ? "bg-[#000] text-[#FFFFFF] shadow-sm z-10"
                  : "bg-transparent text-[#212121]/70 z-10"
              }`}
            >
              Activity
            </button>
          </div>
        </div>
      ) : (
        <div className="flex items-start">
          <div className="inline-flex rounded-t-lg rounded-tr-[20px] bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 py-0.5 px-1 space-x-2 overflow-x-auto hide-scrollbar max-w-full relative shadow-sm border border-slate-200/40">
            <div className="absolute inset-0 rounded-[inherit] bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
            <button
              onClick={() => {
                setActiveTab("assets");
                setSearchQuery("");
                setSidebarMode(null);
              }}
              className={`px-4 py-2 text-sm rounded-lg whitespace-nowrap transition-colors duration-200 cursor-pointer font-bold ${
                activeTab === "assets"
                  ? "bg-[#000] text-[#FFFFFF] shadow-sm z-10"
                  : "bg-transparent text-[#212121]/70 z-10"
              }`}
            >
              Assets
            </button>
            <button
              onClick={() => {
                setActiveTab("requests");
                setSearchQuery("");
                setSidebarMode(null);
              }}
              className={`px-4 py-2 text-sm rounded-lg whitespace-nowrap transition-colors duration-200 cursor-pointer font-bold ${
                activeTab === "requests"
                  ? "bg-[#000] text-[#FFFFFF] shadow-sm z-10"
                  : "bg-transparent text-[#212121]/70 z-10"
              }`}
            >
              Request
            </button>
          </div>
        </div>
      )}

      {/* Main Container */}
      {selectedAssetForDetail ? (
        // Detailed Sub-page Renders here!
        <div className="space-y-6 font-sans">
          
          {detailActiveTab === "stock" ? (
            // Stock Layout Grid (Table on Left, Sidebar on Right)
            <div className="grid grid-cols-12 gap-6 items-start w-full">
              <div className={isSidebarOpen ? "col-span-12 xl:col-span-7 transition-all duration-300 space-y-6" : "col-span-12 space-y-6"}>
                
                {/* Asset Description & Stock Distribution cards side-by-side */}
                <div className={`grid gap-6 items-start w-full ${isSidebarOpen ? "grid-cols-1" : "grid-cols-1 md:grid-cols-12"}`}>
                  
                  {/* Left Card: Info and Description */}
                  <div className={`bg-white rounded-3xl border border-slate-100 shadow-xs p-6 text-left ${isSidebarOpen ? "w-full" : "md:col-span-7"}`}>
                    <div className="flex gap-4 items-center mb-6">
                      <div className="w-14 h-14 bg-slate-50 border border-slate-100 rounded-2xl flex items-center justify-center font-bold text-slate-700 text-xs shadow-inner shrink-0 uppercase">
                        {selectedAssetForDetail.name.slice(0, 3)}
                      </div>
                      <div>
                        <h2 className="text-xl font-bold text-slate-900 leading-tight">{selectedAssetForDetail.name}</h2>
                        <span className="text-xs font-bold text-slate-500 block mt-1">{selectedAssetForDetail.type}</span>
                        <span className="text-[10px] text-gray-400 font-bold block mt-1">ID: {selectedAssetForDetail.id}</span>
                      </div>
                    </div>
                    
                    <div className="pt-4 border-t border-slate-50">
                      <span className="text-[10px] text-gray-400 block font-bold uppercase tracking-wider mb-2">Asset Description</span>
                      <div className="p-4 bg-slate-50 border border-slate-100 rounded-2xl font-medium text-slate-800 text-xs leading-relaxed">
                        {selectedAssetForDetail.description || "xd"}
                      </div>
                    </div>
                  </div>

                  {/* Right Card: Stock Distribution Placeholders */}
                  <div className={`bg-white rounded-3xl border border-slate-100 shadow-xs p-6 text-center ${isSidebarOpen ? "w-full" : "md:col-span-5"}`}>
                    <span className="text-[10px] text-gray-400 block font-bold uppercase tracking-wider text-left mb-6">Stock Distribution</span>
                    <div className="py-8 flex flex-col items-center justify-center gap-2">
                      <IconPackage size={44} className="text-slate-300" />
                      <strong className="text-sm text-slate-900 block font-bold">No Stock Data</strong>
                      <span className="text-xs text-gray-400 font-semibold max-w-[250px] leading-relaxed">
                        There is currently no stock distribution data available for this asset.
                      </span>
                    </div>
                  </div>

                </div>

                {/* Stats counts strip matching Screenshot 1 */}
                <div className={`grid gap-3 ${isSidebarOpen ? "grid-cols-2 md:grid-cols-3 lg:grid-cols-4" : "grid-cols-2 sm:grid-cols-4 lg:grid-cols-7"}`}>
                  {[
                    { label: "Total Stock", color: "bg-blue-600", count: stocks[selectedAssetForDetail.id]?.length || "-" },
                    { label: "Available", color: "bg-emerald-500", count: stocks[selectedAssetForDetail.id]?.filter(s => s.status === "Available").length || "-" },
                    { label: "Issued", color: "bg-amber-500", count: stocks[selectedAssetForDetail.id]?.filter(s => s.status === "Issued").length || "-" },
                    { label: "Lost", color: "bg-rose-500", count: stocks[selectedAssetForDetail.id]?.filter(s => s.status === "Lost").length || "-" },
                    { label: "Damage", color: "bg-orange-500", count: stocks[selectedAssetForDetail.id]?.filter(s => s.status === "Damage").length || "-" },
                    { label: "Non Functional", color: "bg-blue-500", count: stocks[selectedAssetForDetail.id]?.filter(s => s.status === "Non Functional").length || "-" },
                    { label: "Under Maintenance", color: "bg-violet-500", count: stocks[selectedAssetForDetail.id]?.filter(s => s.status === "Under Maintenance").length || "-" }
                  ].map((st, idx) => (
                    <div key={idx} className="bg-white p-3 border border-slate-100 rounded-2xl flex items-center justify-between gap-2 shadow-xs">
                      <div className="text-left">
                        <span className="text-[10px] font-bold text-gray-400 block tracking-wide leading-tight">{st.label}</span>
                        <strong className="text-lg font-black text-slate-900 block mt-1">{st.count}</strong>
                      </div>
                      <div className={`w-7 h-7 rounded-xl ${st.color} flex items-center justify-center text-white shrink-0 shadow-sm`}>
                        <IconPackage size={14} />
                      </div>
                    </div>
                  ))}
                </div>

                {/* Table + Inline Stock Panel */}
                <div className="flex gap-4 items-start">
                  {/* Table Toolbar & Content */}
                  <div className={`bg-white border border-slate-100 rounded-3xl overflow-hidden shadow-xs transition-all duration-300 ${stockPanelMode ? "flex-1 min-w-0" : "w-full"}`}>
                  {/* Mini Toolbar */}
                  <div className="px-5 py-2.5 flex flex-col md:flex-row md:items-center justify-between gap-3 border-b border-slate-50 bg-slate-50/10">
                    <div className="flex items-center gap-2">
                      <div className="relative">
                        <input
                          type="text"
                          placeholder="Search..."
                          value={stockSearchQuery}
                          onChange={e => setStockSearchQuery(e.target.value)}
                          className="pl-3 pr-4 h-8 text-xs rounded-lg border border-slate-200 bg-white outline-none w-36 font-semibold"
                        />
                      </div>
                      <button 
                        onClick={() => setStockPanelMode(stockPanelMode === "FILTER_STOCK" ? null : "FILTER_STOCK")}
                        className={`flex items-center gap-1.5 px-3 h-8 border text-xs font-bold rounded-lg transition cursor-pointer ${stockPanelMode === "FILTER_STOCK" ? "bg-[#FBD037] border-[#FBD037] text-black" : "bg-white border-slate-200 text-slate-700"}`}
                      >
                        <IconFilter size={14} /> Filter
                      </button>
                    </div>
                    
                    <div className="flex items-center gap-2">
                      <button 
                        onClick={() => toast.success("Refreshed stocks list")}
                        className="w-8 h-8 flex items-center justify-center bg-white border border-slate-200 text-slate-700 rounded-lg cursor-pointer hover:bg-slate-50 transition shadow-xs"
                      >
                        <IconRefresh size={14} />
                      </button>
                      <button 
                        onClick={() => setStockPanelMode(stockPanelMode === "IMPORT_STOCK" ? null : "IMPORT_STOCK")}
                        className={`border px-3 h-8 rounded-lg flex items-center gap-1 text-xs font-semibold cursor-pointer transition ${stockPanelMode === "IMPORT_STOCK" ? "bg-[#FBD037] border-[#FBD037] text-black" : "bg-white border-slate-200 text-slate-700 hover:bg-slate-50"}`}
                      >
                        <IconUpload size={14} /> Import
                      </button>
                      <button 
                        onClick={() => toast.success("Stock details exported")}
                        className="border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 px-3 h-8 rounded-lg flex items-center gap-1 text-xs font-semibold cursor-pointer"
                      >
                        <IconDownload size={14} /> Export
                      </button>
                      <button 
                        onClick={() => {
                          setStockFormItems([
                            {
                              serialNo: "",
                              vendor: "",
                              companyName: "",
                              assetValue: "",
                              purchaseDate: "",
                              warrantyDate: "",
                              insuranceStartDate: "",
                              insuranceEndDate: "",
                              insurancePremium: "",
                              modelNumber: "",
                              location: "",
                              department: "",
                              specification: "",
                              attachmentName: ""
                            }
                          ]);
                          setStockPanelMode(stockPanelMode === "ADD_STOCK" ? null : "ADD_STOCK");
                        }} 
                        className={`px-3.5 h-8 rounded-lg flex items-center gap-1 text-xs font-bold cursor-pointer border-none shadow-xs transition ${stockPanelMode === "ADD_STOCK" ? "bg-[#FBD037] text-black" : "bg-black hover:bg-slate-900 text-white"}`}
                      >
                        <IconPlus size={14} /> Add Stock
                      </button>
                      <button disabled className="w-8 h-8 flex items-center justify-center bg-white border border-slate-200 text-slate-400 rounded-lg cursor-not-allowed">
                        <IconLayoutGrid size={14} />
                      </button>
                    </div>
                  </div>

                  {/* Stock Table Content */}
                  <div className="pb-2 overflow-x-auto">
                    {paginatedStocksList.length > 0 ? (
                      <>
                        <table className="w-full text-xs text-left border-collapse min-w-[900px]">
                          <thead>
                            <tr className="bg-[#F8FAFC]/60 border-b border-slate-200/80 font-semibold text-[#131327]/70 text-[11px] tracking-wider uppercase">
                              <th className="py-4 px-4 w-8">
                                <div className="flex items-center justify-center">
                                  <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                                    <input
                                      type="checkbox"
                                      className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                                      checked={paginatedStocksList.length > 0 && paginatedStocksList.every(s => selectedStocks.includes(s.id))}
                                      onChange={e => {
                                        if (e.target.checked) {
                                          setSelectedStocks(paginatedStocksList.map(s => s.id));
                                        } else {
                                          setSelectedStocks([]);
                                        }
                                      }}
                                    />
                                    <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                                      ✓
                                    </span>
                                  </label>
                                </div>
                              </th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">SERIAL NO</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">COMPANY NAME</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">ASSET VALUE</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">VENDOR</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">WARRANTY DATE</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">WARRANTY STATUS</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">STATUS</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">CREATED AT</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">UPDATED AT</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider text-center">ACTIONS</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100 text-xs text-slate-700">
                            {paginatedStocksList.map(s => (
                              <tr key={s.id} className="hover:bg-[#FBD037]/5 transition-colors border-b border-slate-100">
                                <td className="py-4 px-4">
                                  <div className="flex items-center justify-center">
                                    <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                                      <input
                                        type="checkbox"
                                        className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                                        checked={selectedStocks.includes(s.id)}
                                        onChange={e => {
                                          if (e.target.checked) {
                                            setSelectedStocks(prev => [...prev, s.id]);
                                          } else {
                                            setSelectedStocks(prev => prev.filter(id => id !== s.id));
                                          }
                                        }}
                                      />
                                      <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                                        ✓
                                      </span>
                                    </label>
                                  </div>
                                </td>
                                <td className="py-4 px-4 font-mono font-bold text-slate-800">{s.serialNo}</td>
                                <td className="py-4 px-4 font-semibold text-slate-700">{s.companyName}</td>
                                <td className="py-4 px-4 font-mono font-semibold text-slate-800">{s.assetValue}</td>
                                <td className="py-4 px-4 font-semibold text-slate-700">{s.vendor}</td>
                                <td className="py-4 px-4 font-mono text-gray-400">{s.warrantyDate}</td>
                                <td className="py-4 px-4">
                                  <span className={`px-2.5 py-0.5 rounded font-extrabold text-[9px] border ${
                                    s.warrantyStatus === "In Warranty"
                                      ? "bg-green-50 text-green-700 border-green-200"
                                      : "bg-red-50 text-red-600 border-red-200"
                                  }`}>
                                    {s.warrantyStatus}
                                  </span>
                                </td>
                                <td className="py-4 px-4">
                                  <span className="px-2.5 py-0.5 rounded bg-slate-100 text-slate-700 border border-slate-200 text-[9px] font-extrabold">
                                    {s.status}
                                  </span>
                                </td>
                                <td className="py-4 px-4 font-mono text-[9px] text-gray-400">{s.createdAt}</td>
                                <td className="py-4 px-4 font-mono text-[9px] text-gray-400">{s.updatedAt}</td>
                                <td className="py-4 px-4">
                                  <div className="relative flex justify-center">
                                    <button
                                      onClick={() => setActiveActionMenuId(activeActionMenuId === s.id ? null : s.id)}
                                      className="w-7 h-7 rounded-full border border-slate-200 flex items-center justify-center hover:bg-slate-50 text-slate-500 cursor-pointer bg-white transition"
                                    >
                                      <IconDots size={14} />
                                    </button>
                                    {activeActionMenuId === s.id && (
                                      <>
                                        <div className="fixed inset-0 z-40" onClick={() => setActiveActionMenuId(null)} />
                                        <div className="absolute right-0 top-8 z-50 bg-white border border-gray-200 rounded-xl shadow-lg py-1.5 text-left font-sans text-xs font-semibold min-w-[100px]">
                                          <button 
                                            onClick={() => {
                                              if (window.confirm("Are you sure you want to remove this stock record?")) {
                                                setStocks(prev => ({
                                                  ...prev,
                                                  [selectedAssetForDetail.id]: prev[selectedAssetForDetail.id].filter(st => st.id !== s.id)
                                                }));
                                                toast.success("Stock record removed");
                                              }
                                              setActiveActionMenuId(null);
                                            }}
                                            className="w-full px-4 py-2 hover:bg-rose-50 text-rose-650 transition-colors text-left border-none bg-transparent cursor-pointer"
                                          >
                                            Delete
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Stock Table Pagination footer */}
                        <div className="px-6 py-4 flex items-center justify-between border-t border-slate-100 bg-white font-sans text-xs font-semibold text-slate-500">
                          <div className="flex items-center gap-1">
                            <span>Record {filteredStocksList.length > 0 ? (stockCurrentPage - 1) * stockPageSize + 1 : 0}-{Math.min(stockCurrentPage * stockPageSize, filteredStocksList.length)} of {filteredStocksList.length}</span>
                          </div>
                          <div className="flex items-center gap-4">
                            <div className="flex items-center gap-1.5">
                              <select
                                value={stockPageSize}
                                onChange={e => {
                                  setStockPageSize(Number(e.target.value));
                                  setStockCurrentPage(1);
                                }}
                                className="bg-white border border-slate-200 rounded-lg px-2 py-0.5 text-slate-700 font-bold outline-none cursor-pointer text-xs"
                              >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                              </select>
                            </div>
                            <div className="flex items-center gap-1">
                              <button
                                disabled={stockCurrentPage === 1}
                                onClick={() => setStockCurrentPage(prev => Math.max(prev - 1, 1))}
                                className="w-7 h-7 flex items-center justify-center rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition"
                              >
                                <IconChevronLeft size={14} />
                              </button>
                              <span className="text-slate-800 font-bold px-1">{stockCurrentPage} / {Math.ceil(filteredStocksList.length / stockPageSize) || 1}</span>
                              <button
                                disabled={stockCurrentPage === Math.ceil(filteredStocksList.length / stockPageSize) || Math.ceil(filteredStocksList.length / stockPageSize) === 0}
                                onClick={() => setStockCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredStocksList.length / stockPageSize)))}
                                className="w-7 h-7 flex items-center justify-center rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition"
                              >
                                <IconChevronRight size={14} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <table className="w-full text-xs text-left border-collapse min-w-[900px]">
                          <thead>
                            <tr className="bg-[#F8FAFC]/60 border-b border-slate-200/80 font-semibold text-[#131327]/70 text-[11px] tracking-wider uppercase">
                              <th className="py-4 px-4 w-8">
                                <div className="flex items-center justify-center">
                                  <label className="relative flex items-center justify-center cursor-not-allowed h-4 w-4">
                                    <input
                                      type="checkbox"
                                      disabled
                                      className="peer h-4 w-4 cursor-not-allowed appearance-none rounded border border-slate-200 bg-slate-50 transition-all"
                                    />
                                    <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                                      ✓
                                    </span>
                                  </label>
                                </div>
                              </th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">SERIAL NO</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">COMPANY NAME</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">ASSET VALUE</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">VENDOR</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">WARRANTY DATE</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">WARRANTY STATUS</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">STATUS</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">CREATED AT</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider">UPDATED AT</th>
                              <th className="py-4 px-4 text-[11px] tracking-wider text-center">ACTIONS</th>
                            </tr>
                          </thead>
                        </table>
                        
                        {/* Table Empty State Placeholder */}
                        <div className="py-16 flex flex-col items-center justify-center gap-2 bg-white">
                          <IconFileText size={44} className="text-slate-300" />
                          <strong className="text-sm text-slate-900 block font-bold">No Data found</strong>
                          <span className="text-xs text-gray-400 font-semibold max-w-[250px] leading-relaxed">
                            We couldn't find any data to show here.
                          </span>
                        </div>
                      </>
                    )}
                  </div>{/* end overflow-x-auto */}
                  </div>{/* end table card (bg-white rounded-3xl) */}

                  {/* Inline Stock Panel - slides in next to the table */}
                  {stockPanelMode && (
                    <div className="w-[400px] shrink-0 flex flex-col bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden font-sans" style={{animation: 'slideInRight 0.2s ease'}}>
                      
                      {/* FILTER STOCK */}
                      {stockPanelMode === "FILTER_STOCK" && (
                        <>
                          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
                            <h2 className="text-lg font-bold text-[#212121]">Filter Stock</h2>
                            <button onClick={() => setStockPanelMode(null)} className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"><IconX size={18} /></button>
                          </div>
                          <div className="p-6 bg-white space-y-4 text-left font-semibold text-gray-700">
                            <div className="space-y-1.5">
                              <label className="block text-xs font-bold text-[#1E293B]">Select Status</label>
                              <select value={stockStatusFilter} onChange={e => setStockStatusFilter(e.target.value)} className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer">
                                <option value="All">Select Status</option>
                                <option value="Available">Available</option>
                                <option value="Issued">Issued</option>
                                <option value="Lost">Lost</option>
                                <option value="Damage">Damage</option>
                                <option value="Non Functional">Non Functional</option>
                                <option value="Under Maintenance">Under Maintenance</option>
                              </select>
                            </div>
                            <div className="space-y-1.5">
                              <label className="block text-xs font-bold text-[#1E293B]">Select Warranty Status</label>
                              <select value={stockWarrantyFilter} onChange={e => setStockWarrantyFilter(e.target.value)} className="w-full px-4 py-2.5 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer">
                                <option value="All">Select Warranty Status</option>
                                <option value="In Warranty">In Warranty</option>
                                <option value="Expired">Expired</option>
                              </select>
                            </div>
                            <div className="pt-4 border-t border-slate-100 flex gap-2 justify-end font-bold">
                              <button onClick={() => { setStockStatusFilter("All"); setStockWarrantyFilter("All"); toast.success("Filters cleared"); setStockPanelMode(null); }} className="px-4 py-2 border border-gray-200 hover:bg-gray-50 text-slate-700 rounded-xl text-xs font-bold transition cursor-pointer bg-white">Clear</button>
                              <button onClick={() => setStockPanelMode(null)} className="px-5 py-2 bg-black text-[#FBD037] hover:bg-slate-900 text-xs font-bold rounded-xl transition cursor-pointer border-none shadow-sm">Apply</button>
                            </div>
                          </div>
                        </>
                      )}

                      {/* IMPORT STOCK */}
                      {stockPanelMode === "IMPORT_STOCK" && (
                        <>
                          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white">
                            <h2 className="text-lg font-bold text-[#212121]">Import Stock Details</h2>
                            <button onClick={() => setStockPanelMode(null)} className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"><IconX size={18} /></button>
                          </div>
                          <div className="p-6 space-y-5 text-left font-semibold text-gray-700">
                            <div className="p-3 bg-blue-50 border border-blue-100 rounded-xl">
                              <p className="text-xs font-bold text-blue-700">Expected CSV Columns:</p>
                              <p className="text-[11px] text-blue-600 mt-1 font-medium leading-relaxed">Serial No, Company Name, Asset Value, Vendor, Warranty Date</p>
                            </div>
                            <div>
                              <label className="block text-xs font-bold text-[#1E293B] mb-1.5">Upload CSV / Excel File</label>
                              <div className="border-2 border-dashed border-gray-200 hover:border-[#FBD037] transition rounded-2xl p-8 flex flex-col items-center justify-center gap-2 cursor-pointer bg-slate-50 relative">
                                <input type="file" accept=".csv,.xlsx,.xls" className="absolute inset-0 opacity-0 cursor-pointer" />
                                <IconUpload size={28} className="text-gray-400" />
                                <span className="text-xs font-bold text-slate-700">Drag &amp; drop or click to browse</span>
                                <span className="text-[10px] text-gray-400">CSV or Excel files only • Max 10MB</span>
                              </div>
                            </div>
                            <div className="pt-4 border-t border-slate-100 flex gap-2 justify-end">
                              <button onClick={() => setStockPanelMode(null)} className="px-4 py-2 border border-gray-200 hover:bg-gray-50 text-slate-700 rounded-xl text-xs font-bold transition cursor-pointer bg-white">Cancel</button>
                              <button onClick={() => { toast.success("Import started!"); setStockPanelMode(null); }} className="px-5 py-2 bg-black text-[#FBD037] hover:bg-slate-900 text-xs font-bold rounded-xl transition cursor-pointer border-none shadow-sm">Import</button>
                            </div>
                          </div>
                        </>
                      )}

                      {/* ADD STOCK */}
                      {stockPanelMode === "ADD_STOCK" && (
                        <>
                          <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100 bg-white shadow-xs">
                            <h2 className="text-lg font-bold text-[#212121]">Add Stock</h2>
                            <button onClick={() => setStockPanelMode(null)} className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition text-slate-700 cursor-pointer"><IconX size={18} /></button>
                          </div>
                          <form onSubmit={handleAddStockSubmit} className="bg-white p-6 max-h-[calc(100vh-200px)] overflow-y-auto space-y-6 text-left font-semibold text-gray-700">
                            {stockFormItems.map((item, idx) => (
                              <div key={idx} className="p-4 border border-slate-150 bg-slate-50/20 rounded-2xl relative space-y-4">
                                <div className="flex justify-between items-center pb-2 border-b border-slate-100">
                                  <span className="text-[11px] font-black text-[#212121] uppercase tracking-wide">Stock Item #{idx + 1}</span>
                                  {stockFormItems.length > 1 && (
                                    <button type="button" onClick={() => setStockFormItems(prev => prev.filter((_, i) => i !== idx))} className="p-1 rounded bg-rose-50 border border-rose-200 text-rose-600 hover:bg-rose-100 transition cursor-pointer"><IconTrash size={13} /></button>
                                  )}
                                </div>
                                <div className="grid grid-cols-2 gap-3">
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Serial No *</label>
                                    <input type="text" required value={item.serialNo} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, serialNo: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" placeholder="XXXX-XXXX" />
                                  </div>
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Vendor *</label>
                                    <select value={item.vendor} required onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, vendor: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer">
                                      <option value="">Select Vendor</option>
                                      {vendors.map(v => <option key={v} value={v}>{v}</option>)}
                                    </select>
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 gap-3">
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Company Name</label>
                                    <input type="text" value={item.companyName} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, companyName: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" placeholder="Company Name" />
                                  </div>
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Asset Value</label>
                                    <input type="number" value={item.assetValue} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, assetValue: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" placeholder="Asset Value" />
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 gap-3">
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Purchase Date</label>
                                    <input type="date" value={item.purchaseDate} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, purchaseDate: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] font-mono cursor-pointer" />
                                  </div>
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Warranty Date</label>
                                    <input type="date" value={item.warrantyDate} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, warrantyDate: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] font-mono cursor-pointer" />
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 gap-3">
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Insurance Start Date</label>
                                    <input type="date" value={item.insuranceStartDate} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, insuranceStartDate: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] font-mono cursor-pointer" />
                                  </div>
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Insurance End Date</label>
                                    <input type="date" value={item.insuranceEndDate} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, insuranceEndDate: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] font-mono cursor-pointer" />
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 gap-3">
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Insurance Premium</label>
                                    <input type="number" value={item.insurancePremium} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, insurancePremium: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" placeholder="Enter premium amount" />
                                  </div>
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Model Number</label>
                                    <input type="text" value={item.modelNumber} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, modelNumber: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" placeholder="Enter model number" />
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 gap-3">
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Location</label>
                                    <input type="text" value={item.location} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, location: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121]" placeholder="Enter location" />
                                  </div>
                                  <div className="space-y-1.5">
                                    <label className="block text-xs font-bold text-[#1E293B]">Department</label>
                                    <select value={item.department} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, department: val } : form)); }} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] cursor-pointer">
                                      <option value="">Select Department</option>
                                      {departments.map(d => <option key={d} value={d}>{d}</option>)}
                                    </select>
                                  </div>
                                </div>
                                <div className="space-y-1.5">
                                  <label className="block text-xs font-bold text-[#1E293B]">Specification *</label>
                                  <textarea required value={item.specification} onChange={e => { const val = e.target.value; setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, specification: val } : form)); }} placeholder="Enter Specification" rows={3} className="w-full px-3 py-2 bg-white border border-gray-200 rounded-xl outline-none focus:ring-1 focus:ring-[#FBD037] text-xs font-semibold text-[#212121] resize-none" />
                                </div>
                                <div className="space-y-1.5">
                                  <label className="block text-xs font-bold text-[#1E293B]">Attachments</label>
                                  <div className="border border-dashed border-gray-200 hover:border-[#FBD037] transition rounded-2xl p-4 flex flex-col items-center justify-center gap-1 cursor-pointer bg-slate-50/10 relative">
                                    <input type="file" onChange={(e) => { const file = e.target.files?.[0]; if (file) { setStockFormItems(prev => prev.map((form, i) => i === idx ? { ...form, attachmentName: file.name } : form)); } }} className="absolute inset-0 opacity-0 cursor-pointer" />
                                    <IconUpload size={20} className="text-gray-400" />
                                    <span className="text-xs font-bold text-slate-700 text-center">{item.attachmentName || "Drag & drop or click"}</span>
                                    <span className="text-[9px] text-gray-400 mt-0.5">Max 10 files • 3MB each</span>
                                  </div>
                                </div>
                              </div>
                            ))}
                            <div className="pt-2 flex justify-start">
                              <button type="button" onClick={() => { setStockFormItems(prev => [...prev, { serialNo: "", vendor: "", companyName: "", assetValue: "", purchaseDate: "", warrantyDate: "", insuranceStartDate: "", insuranceEndDate: "", insurancePremium: "", modelNumber: "", location: "", department: "", specification: "", attachmentName: "" }]); }} className="bg-black hover:bg-slate-900 text-[#FBD037] px-4 py-2.5 rounded-xl flex items-center gap-1.5 text-xs font-extrabold shadow-sm transition cursor-pointer border-none">
                                <IconPlus stroke={3} size={15} /> Add More
                              </button>
                            </div>
                            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100 font-bold">
                              <button type="button" onClick={() => setStockPanelMode(null)} className="px-4 py-2 border border-gray-200 hover:bg-gray-50 rounded-xl text-xs font-bold text-gray-700 transition cursor-pointer bg-white">Cancel</button>
                              <button type="submit" disabled={isSubmitting} className="px-5 py-2 bg-black text-[#FBD037] hover:bg-slate-900 text-xs font-bold rounded-xl transition cursor-pointer border-none shadow-sm">{isSubmitting ? "Saving..." : "Save"}</button>
                            </div>
                          </form>
                        </>
                      )}

                    </div>
                  )}
                </div>{/* end flex stock panel wrapper */}

              </div>

              {/* Desktop Right Sidebar Column */}
              {isSidebarOpen && (
                <div className="hidden xl:block xl:col-span-5 space-y-4 mt-2">
                  {sidebarContent}
                </div>
              )}
            </div>
          ) : (
            // Activity Logs Timeline matching Screenshot 2
            <div className="bg-white rounded-3xl border border-slate-100 shadow-xs p-6 space-y-4">
              
              {/* Event 1 */}
              <div className="p-4 border border-slate-100 rounded-2xl shadow-xs text-left flex gap-4 items-start hover:border-slate-200 transition">
                <div className="w-9 h-9 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center shrink-0">
                  <IconEdit size={16} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-bold text-slate-900 text-sm">Stock Request Created by Yash Koladiya</h3>
                    <span className="px-2 py-0.5 rounded bg-blue-100 text-blue-700 font-bold text-[8px] uppercase tracking-wide">update</span>
                  </div>
                  <p className="text-xs text-gray-500 font-medium mt-1 leading-relaxed">Yash Koladiya requested 2 stock for asset Speaker.</p>
                  
                  <div className="flex items-center gap-4 mt-3 pt-3 border-t border-slate-50 flex-wrap">
                    <div className="flex items-center gap-1.5">
                      <div className="w-5 h-5 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center font-bold text-[8px]">YK</div>
                      <span className="text-[10px] text-gray-400 font-bold">Yash Koladiya</span>
                    </div>
                    <div className="flex items-center gap-1 text-[10px] text-gray-400 font-bold">
                      <IconClock size={12} /> 22 days ago
                    </div>
                  </div>
                </div>
              </div>

              {/* Event 2 */}
              <div className="p-4 border border-slate-100 rounded-2xl shadow-xs text-left flex gap-4 items-start hover:border-slate-200 transition">
                <div className="w-9 h-9 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0">
                  <IconPlus size={16} stroke={3} />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-bold text-slate-900 text-sm">Asset Created by Yash Koladiya</h3>
                    <span className="px-2 py-0.5 rounded bg-emerald-100 text-emerald-700 font-bold text-[8px] uppercase tracking-wide">creation</span>
                  </div>
                  <p className="text-xs text-gray-500 font-medium mt-1 leading-relaxed">Yash Koladiya has created a new assets: Speaker.</p>
                  
                  <div className="flex items-center gap-4 mt-3 pt-3 border-t border-slate-50 flex-wrap">
                    <div className="flex items-center gap-1.5">
                      <div className="w-5 h-5 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center font-bold text-[8px]">YK</div>
                      <span className="text-[10px] text-gray-400 font-bold">Yash Koladiya</span>
                    </div>
                    <div className="flex items-center gap-1 text-[10px] text-gray-400 font-bold">
                      <IconClock size={12} /> 22 days ago
                    </div>
                  </div>
                </div>
              </div>

            </div>
          )}

        </div>
      ) : (
        // Main list tables container
        <div className="bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl rounded-b-3xl rounded-tr-3xl border border-white/20 shadow-sm overflow-hidden mb-6">
          
          {/* Toolbar Row */}
          <div className="px-6 py-1.5 flex flex-col lg:flex-row lg:items-center justify-between gap-4 border-b border-slate-50 bg-slate-50/10">
            
            {/* Left Toolbar */}
            <div className="flex items-center gap-2.5">
              {activeTab === "assets" ? (
                <>
                  <select
                    value={assetTypeFilter}
                    onChange={e => setAssetTypeFilter(e.target.value)}
                    className="border border-slate-200 rounded-lg px-3.5 h-8 text-xs font-semibold bg-white outline-none focus:ring-1 focus:ring-[#FBD037] cursor-pointer"
                  >
                    <option value="All">Select Asset Type...</option>
                    {assetTypes.map(t => (
                      <option key={t.name} value={t.name}>{t.name}</option>
                    ))}
                  </select>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search Here..."
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      className="pl-3 pr-4 h-8 text-xs rounded-lg border border-slate-200 bg-white outline-none focus:ring-1 focus:ring-[#FBD037] font-semibold w-40"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      className="pl-3 pr-4 h-8 text-xs rounded-lg border border-slate-200 bg-white outline-none focus:ring-1 focus:ring-[#FBD037] font-semibold w-40"
                    />
                  </div>
                  <button
                    onClick={() => setSidebarMode("FILTER_REQUEST")}
                    className="flex items-center gap-1.5 px-3.5 h-8 bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 text-xs font-bold rounded-lg transition cursor-pointer"
                  >
                    <IconFilter size={14} /> Filter
                  </button>
                </>
              )}
            </div>

            {/* Right Toolbar */}
            <div className="flex items-center flex-wrap gap-2.5">
              {/* Bulk delete actions */}
              {activeTab === "assets" && selectedAssets.length > 0 && (
                <button
                  onClick={handleDeleteSelectedAssets}
                  className="bg-red-50 text-red-600 border border-red-200 px-3 h-8 rounded-lg flex items-center gap-1.5 text-xs font-bold hover:bg-red-100 transition shadow-sm mr-2 cursor-pointer border-none"
                >
                  <IconTrash size={14} /> Delete ({selectedAssets.length})
                </button>
              )}
              {activeTab === "requests" && selectedRequests.length > 0 && (
                <button
                  onClick={handleDeleteSelectedRequests}
                  className="bg-red-50 text-red-655 border border-red-200 px-3 h-8 rounded-lg flex items-center gap-1.5 text-xs font-bold hover:bg-red-100 transition shadow-sm mr-2 cursor-pointer border-none"
                >
                  <IconTrash size={14} /> Delete ({selectedRequests.length})
                </button>
              )}

              {/* Import / Export / Refresh / Add toolbar buttons */}
              <button
                onClick={() => {
                  if (activeTab === "assets") setSidebarMode("IMPORT_ASSET");
                  else setSidebarMode("IMPORT_REQUEST");
                }}
                className="border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 px-3 h-8 rounded-lg flex items-center gap-1.5 text-xs font-semibold transition shadow-sm cursor-pointer"
              >
                <IconUpload size={14} /> Import
              </button>
              
              {activeTab === "assets" && (
                <button
                  onClick={() => toast.success("Assets export started")}
                  className="border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 px-3 h-8 rounded-lg flex items-center gap-1.5 text-xs font-semibold transition shadow-sm cursor-pointer"
                >
                  <IconDownload size={14} /> Export
                </button>
              )}

              <button
                onClick={() => {
                  toast.success("List refreshed");
                }}
                className="w-8 h-8 flex items-center justify-center bg-white hover:bg-slate-50 border border-slate-200 text-slate-700 rounded-lg transition shadow-sm cursor-pointer"
                title="Refresh"
              >
                <IconRefresh size={15} />
              </button>

              <button
                onClick={() => {
                  if (activeTab === "assets") {
                    setNewAssetName("");
                    setNewAssetDesc("");
                    setNewAssetType("Electronics");
                    setSidebarMode("ADD_ASSET");
                  } else {
                    setSidebarMode("ADD_REQUEST");
                  }
                }}
                className="flex items-center justify-center w-8 h-8 rounded-lg bg-[#FBD037] hover:bg-[#FACC15] text-[#212121] transition shadow-sm active:scale-95 cursor-pointer border-none"
                title={activeTab === "assets" ? "Add Asset" : "Add Request"}
              >
                <IconPlus stroke={2.5} size={15} />
              </button>
            </div>
          </div>

          {/* Layout Grid (Table on Left, Sidebar on Right) */}
          <div className="grid grid-cols-12 gap-6 p-2 items-start w-full">
            <div className={isSidebarOpen ? "col-span-12 xl:col-span-7 transition-all duration-300" : "col-span-12"}>
              <div className="pb-2 overflow-x-auto">
                
                {activeTab === "assets" ? (
                  // Assets Inventory Table
                  <>
                    <table className="w-full text-xs text-left border-collapse min-w-[900px]">
                      <thead>
                        <tr className="bg-[#F8FAFC]/60 border-b border-slate-200/80 font-semibold text-[#131327]/70 text-[11px] tracking-wider uppercase">
                          <th className="py-4 px-4 w-8">
                            <div className="flex items-center justify-center">
                              <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                                <input
                                  type="checkbox"
                                  className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                                  checked={paginatedAssets.length > 0 && paginatedAssets.every(item => selectedAssets.includes(item.id))}
                                  onChange={e => {
                                    if (e.target.checked) {
                                      setSelectedAssets(paginatedAssets.map(i => i.id));
                                    } else {
                                      setSelectedAssets([]);
                                    }
                                  }}
                                />
                                <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                                  ✓
                                </span>
                              </label>
                            </div>
                          </th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">SR.NO</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">UNIQUE ID</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider text-center">ASSET PICTURE</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">ASSET NAME</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">ASSET TYPE</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">TOTAL STOCK</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">AVAILABLE STOCK</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider text-center">LENT TO</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">CREATED AT</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">UPDATED AT</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider text-center">ACTIONS</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100 text-xs text-slate-700">
                        {paginatedAssets.map((item, idx) => {
                          const isLowStock = item.totalStock === "Low Stock";
                          const isLent = typeof item.lentTo === "number";
                          const globalIdx = (currentPage - 1) * pageSize + idx + 1;
                          return (
                            <tr key={item.id} className="hover:bg-[#FBD037]/5 transition-colors border-b border-slate-100">
                              <td className="py-4 px-4">
                                <div className="flex items-center justify-center">
                                  <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                                    <input
                                      type="checkbox"
                                      className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                                      checked={selectedAssets.includes(item.id)}
                                      onChange={e => {
                                        if (e.target.checked) {
                                          setSelectedAssets(prev => [...prev, item.id]);
                                        } else {
                                          setSelectedAssets(prev => prev.filter(id => id !== item.id));
                                        }
                                      }}
                                    />
                                    <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                                      ✓
                                    </span>
                                  </label>
                                </div>
                              </td>
                              <td className="py-4 px-4 text-slate-400 font-semibold">{globalIdx}</td>
                              <td className="py-4 px-4 font-bold text-slate-800">{item.id}</td>
                              <td className="py-4 px-4">
                                <div className="flex justify-center">
                                  {item.picture.startsWith("http") ? (
                                    <img src={item.picture} className="w-9 h-9 rounded-xl object-cover border border-slate-100 shadow-sm" alt={item.name} />
                                  ) : (
                                    <span className="text-[10px] text-slate-400 font-bold bg-slate-50 border border-slate-200/60 rounded-lg px-2.5 py-1">No Image</span>
                                  )}
                                </div>
                              </td>
                              <td className="py-4 px-4 font-extrabold text-slate-900 cursor-pointer" onClick={() => {
                                setSelectedAssetForDetail(item);
                                setDetailActiveTab("stock");
                              }}>
                                <span className="hover:text-black hover:underline">{item.name}</span>
                              </td>
                              <td className="py-4 px-4 font-semibold text-slate-600">{item.type}</td>
                              <td className="py-4 px-4">
                                {isLowStock ? (
                                  <span className="text-red-500 font-bold text-xs">{item.totalStock}</span>
                                ) : (
                                  <span className="font-semibold text-slate-850">{item.totalStock}</span>
                                )}
                              </td>
                              <td className="py-4 px-4 font-semibold text-slate-800">{item.availableStock}</td>
                              <td className="py-4 px-4 text-center">
                                {isLent ? (
                                  <span className="w-5 h-5 rounded-full bg-slate-850 text-white flex items-center justify-center font-bold text-[10px] font-mono shadow-xs mx-auto">
                                    {item.lentTo}
                                  </span>
                                ) : (
                                  <span className="text-slate-400 font-semibold">-</span>
                                )}
                              </td>
                              <td className="py-4 px-4 font-semibold text-slate-400">{item.createdAt}</td>
                              <td className="py-4 px-4 font-semibold text-slate-400">{item.updatedAt}</td>
                              <td className="py-4 px-4">
                                <div className="relative flex justify-center">
                                  <button
                                    onClick={() => setActiveActionMenuId(activeActionMenuId === item.id ? null : item.id)}
                                    className="w-7 h-7 rounded-full border border-slate-200 flex items-center justify-center hover:bg-slate-50 text-slate-500 cursor-pointer bg-white transition"
                                  >
                                    <IconDots size={14} />
                                  </button>
                                  {activeActionMenuId === item.id && (
                                    <>
                                      <div className="fixed inset-0 z-40" onClick={() => setActiveActionMenuId(null)} />
                                      <div className="absolute right-0 top-8 z-50 bg-white border border-gray-200 rounded-xl shadow-lg py-1.5 text-left font-sans text-xs font-semibold min-w-[120px]">
                                        <button 
                                          onClick={() => {
                                            setSelectedAssetForDetail(item);
                                            setDetailActiveTab("stock");
                                            setActiveActionMenuId(null);
                                          }}
                                          className="w-full px-4 py-2 hover:bg-gray-50 transition-colors text-slate-700 text-left border-none bg-transparent cursor-pointer"
                                        >
                                          View
                                        </button>
                                        <button 
                                          onClick={() => {
                                            setSelectedAssetForEdit(item);
                                            setNewAssetName(item.name);
                                            setNewAssetType(item.type === "-" ? "Electronics" : item.type);
                                            setNewAssetDesc(item.description || "xd");
                                            setSidebarMode("EDIT_ASSET");
                                            setActiveActionMenuId(null);
                                          }}
                                          className="w-full px-4 py-2 hover:bg-gray-50 transition-colors text-slate-700 text-left border-none bg-transparent cursor-pointer"
                                        >
                                          Edit
                                        </button>
                                        <button 
                                          onClick={() => {
                                            setSelectedAssetForDelete(item);
                                            setSidebarMode("DELETE_ASSET_CONFIRM");
                                            setActiveActionMenuId(null);
                                          }}
                                          className="w-full px-4 py-2 hover:bg-rose-50 text-rose-600 transition-colors text-left border-none bg-transparent cursor-pointer"
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    {/* Pagination footer for Assets */}
                    <div className="px-6 py-4 flex items-center justify-between border-t border-slate-100 bg-white font-sans text-xs font-semibold text-slate-500">
                      <div className="flex items-center gap-1">
                        <span>Record {filteredAssets.length > 0 ? (currentPage - 1) * pageSize + 1 : 0}-{Math.min(currentPage * pageSize, filteredAssets.length)} of {filteredAssets.length}</span>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1.5">
                          <select
                            value={pageSize}
                            onChange={e => {
                              setPageSize(Number(e.target.value));
                              setCurrentPage(1);
                            }}
                            className="bg-white border border-slate-200 rounded-lg px-2.5 py-1 text-slate-700 font-bold outline-none cursor-pointer text-xs"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                          </select>
                        </div>
                        <div className="flex items-center gap-1">
                          <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            className="w-7 h-7 flex items-center justify-center rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition"
                          >
                            <IconChevronLeft size={14} />
                          </button>
                          <span className="text-slate-800 font-bold px-1">{currentPage} / {Math.ceil(filteredAssets.length / pageSize) || 1}</span>
                          <button
                            disabled={currentPage === Math.ceil(filteredAssets.length / pageSize) || Math.ceil(filteredAssets.length / pageSize) === 0}
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredAssets.length / pageSize)))}
                            className="w-7 h-7 flex items-center justify-center rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition"
                          >
                            <IconChevronRight size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  // Requests Table
                  <>
                    <table className="w-full text-xs text-left border-collapse min-w-[1000px]">
                      <thead>
                        <tr className="bg-[#F8FAFC]/60 border-b border-slate-200/80 font-semibold text-[#131327]/70 text-[11px] tracking-wider uppercase">
                          <th className="py-4 px-4 w-8">
                            <div className="flex items-center justify-center">
                              <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                                <input
                                  type="checkbox"
                                  className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                                  checked={paginatedRequests.length > 0 && paginatedRequests.every(item => selectedRequests.includes(item.id))}
                                  onChange={e => {
                                    if (e.target.checked) {
                                      setSelectedRequests(paginatedRequests.map(i => i.id));
                                    } else {
                                      setSelectedRequests([]);
                                    }
                                  }}
                                />
                                <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                                  ✓
                                </span>
                              </label>
                            </div>
                          </th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">SR.NO</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">REQUEST NO.</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">ASSET</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">PROJECT</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">TASK</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">SUB TASK</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">VENDOR</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider text-center">REQUESTED BY</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">QUANTITY</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">ACCEPTED QUANTITY</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider">REMARKS</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider text-center">STATUS</th>
                          <th className="py-4 px-4 text-[11px] tracking-wider text-center">ACTIONS</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100 text-xs text-slate-700">
                        {paginatedRequests.map((item, idx) => {
                          const statusColors: Record<string, string> = {
                            Pending: "bg-amber-100 text-amber-800 border-amber-200",
                            Received: "bg-emerald-100 text-emerald-800 border-emerald-200",
                            Scheduled: "bg-orange-100 text-orange-850 border-orange-200",
                            "Not Received": "bg-rose-100 text-rose-800 border-rose-200"
                          };
                          const globalIdx = (currentPage - 1) * pageSize + idx + 1;
                          return (
                            <tr key={item.id} className="hover:bg-[#FBD037]/5 transition-colors border-b border-slate-100">
                              <td className="py-4 px-4">
                                <div className="flex items-center justify-center">
                                  <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
                                    <input
                                      type="checkbox"
                                      className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                                      checked={selectedRequests.includes(item.id)}
                                      onChange={e => {
                                        if (e.target.checked) {
                                          setSelectedRequests(prev => [...prev, item.id]);
                                        } else {
                                          setSelectedRequests(prev => prev.filter(id => id !== item.id));
                                        }
                                      }}
                                    />
                                    <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                                      ✓
                                    </span>
                                  </label>
                                </div>
                              </td>
                              <td className="py-4 px-4 text-slate-400 font-semibold">{globalIdx}</td>
                              <td className="py-4 px-4">
                                <div className="flex flex-col items-start gap-1">
                                  <span className="font-bold font-mono text-gray-800 leading-tight">{item.id}</span>
                                  <span className={`text-[8px] font-bold px-1.5 py-0.5 rounded ${
                                    item.type.includes("Project") 
                                      ? "bg-emerald-500 text-white" 
                                      : item.type.includes("Emp")
                                      ? "bg-amber-500 text-white"
                                      : "bg-blue-600 text-white"
                                  }`}>
                                    {item.type}
                                  </span>
                                </div>
                              </td>
                              <td className="py-4 px-4 font-bold text-slate-800">{item.asset}</td>
                              <td className="py-4 px-4 font-semibold text-slate-600">{item.project}</td>
                              <td className="py-4 px-4 font-semibold text-slate-650">{item.task}</td>
                              <td className="py-4 px-4 text-slate-400 font-medium">{item.subTask}</td>
                              <td className="py-4 px-4 text-slate-400 font-medium">{item.vendor}</td>
                              <td className="py-4 px-4">
                                <div className="flex justify-center">
                                  <div className="w-6 h-6 rounded-full bg-slate-100 border border-slate-200 text-slate-700 flex items-center justify-center font-bold text-[9px] shadow-xs">
                                    {item.requestedBy}
                                  </div>
                                </div>
                              </td>
                              <td className="py-4 px-4 font-semibold text-slate-800">{item.quantity}</td>
                              <td className="py-4 px-4 text-slate-400 font-semibold">{item.acceptedQuantity}</td>
                              <td className="py-4 px-4 font-medium text-gray-500">{item.remarks}</td>
                              <td className="py-4 px-4">
                                <div className="flex justify-center">
                                  <span className={`px-2.5 py-0.5 rounded-full text-[9px] font-bold border ${statusColors[item.status]}`}>
                                    {item.status}
                                  </span>
                                </div>
                              </td>
                              <td className="py-4 px-4">
                                <div className="relative flex justify-center">
                                  <button
                                    onClick={() => setActiveActionMenuId(activeActionMenuId === item.id ? null : item.id)}
                                    className="w-7 h-7 rounded-full border border-slate-200 flex items-center justify-center hover:bg-slate-50 text-slate-500 cursor-pointer bg-white transition"
                                  >
                                    <IconDots size={14} />
                                  </button>
                                  {activeActionMenuId === item.id && (
                                    <>
                                      <div className="fixed inset-0 z-40" onClick={() => setActiveActionMenuId(null)} />
                                      <div className="absolute right-0 top-8 z-50 bg-white border border-gray-200 rounded-xl shadow-lg py-1.5 text-left font-sans text-xs font-semibold min-w-[120px]">
                                        <button 
                                          onClick={() => {
                                            setSelectedReqForView(item);
                                            setSidebarMode("VIEW_REQUEST");
                                            setActiveActionMenuId(null);
                                          }}
                                          className="w-full px-4 py-2 hover:bg-gray-50 transition-colors text-slate-700 text-left border-none bg-transparent cursor-pointer"
                                        >
                                          View
                                        </button>
                                        <button 
                                          onClick={() => {
                                            setSelectedReqForDelete(item);
                                            setSidebarMode("DELETE_REQUEST_CONFIRM");
                                            setActiveActionMenuId(null);
                                          }}
                                          className="w-full px-4 py-2 hover:bg-rose-50 text-rose-600 transition-colors text-left border-none bg-transparent cursor-pointer"
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    {/* Pagination footer for Requests */}
                    <div className="px-6 py-4 flex items-center justify-between border-t border-slate-100 bg-white font-sans text-xs font-semibold text-slate-500">
                      <div className="flex items-center gap-1">
                        <span>Record {filteredRequests.length > 0 ? (currentPage - 1) * pageSize + 1 : 0}-{Math.min(currentPage * pageSize, filteredRequests.length)} of {filteredRequests.length}</span>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-1.5">
                          <select
                            value={pageSize}
                            onChange={e => {
                              setPageSize(Number(e.target.value));
                              setCurrentPage(1);
                            }}
                            className="bg-white border border-slate-200 rounded-lg px-2.5 py-1 text-slate-700 font-bold outline-none cursor-pointer text-xs"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                          </select>
                        </div>
                        <div className="flex items-center gap-1">
                          <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            className="w-7 h-7 flex items-center justify-center rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition"
                          >
                            <IconChevronLeft size={14} />
                          </button>
                          <span className="text-slate-800 font-bold px-1">{currentPage} / {Math.ceil(filteredRequests.length / pageSize) || 1}</span>
                          <button
                            disabled={currentPage === Math.ceil(filteredRequests.length / pageSize) || Math.ceil(filteredRequests.length / pageSize) === 0}
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(filteredRequests.length / pageSize)))}
                            className="w-7 h-7 flex items-center justify-center rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer transition"
                          >
                            <IconChevronRight size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Desktop Right Sidebar Column */}
            {isSidebarOpen && (
              <div className="hidden xl:block xl:col-span-5 space-y-4 mt-2">
                {sidebarContent}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Mobile Right Sidebar Overlay */}
      {isSidebarOpen && (
        <div className="xl:hidden">
          <div className="fixed inset-0 bg-black/40 z-30" onClick={() => setSidebarMode(null)} />
          <div className="fixed inset-y-0 right-0 z-[35] w-full sm:w-[500px] p-4 pt-[76px] sm:pt-[96px] shadow-2xl bg-[#F7F6F2] overflow-y-auto flex flex-col justify-start">
            {sidebarContent}
          </div>
        </div>
      )}
      </>
      )}

    </div>
  );
}
